<!-- eslint-disable no-unused-vars, no-dupe-keys, vue/no-dupe-keys -->
<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex flex-wrap flex-wrap align-items-center justify-content-between mb-4">
                    <div>
                        <h4 class="mb-3">{{ title }}</h4>
                        <p class="mb-0">{{ desc1 }}<br> {{ desc2 }}</p>
                    </div>
                    <b-button variant="primary pl-5 pr-5" class="mt-2 mr-1" @click="updateProductDb()"
                        v-if="showlist">로켓배송 상품DB 업데이트</b-button>
                </div>
            </div>

            <!-- 본문 탭. ⚠ 모달(#excelupload) 안에도 탭이 있고 그쪽은 activeTab 을 쓴다.
                 여기서 같은 변수를 쓰면 모달 탭이 같이 움직이므로 반드시 다른 변수를 쓴다. -->
            <div class="col-lg-12">
                <b-tabs v-model="regPageTab" content-class="mt-3">
                    <b-tab title="등록 상품" active>
                        <div class="row">
            <div class="col-lg-12">
                <img v-if="showspinner" style="max-width:100%;"
                    :src="require('../../../assets/images/small/spinner.gif')">
                <div v-if="showspinner1" class="d-flex justify-content-center">
                    <div><img style="max-width:10%;"
                            :src="require('../../../assets/images/small/loading.gif')">{{ loadingtext }}</div>
                </div>
            </div>

            <!-- 판매현황 수집이 멈추면 판매가가 옛날 값으로 남는다. 화면에 티가 나야 한다(2026-09-02 문의) -->
            <div class="col-lg-12" v-if="showlist && 판매현황경과일 !== null && 판매현황경과일 > 7">
                <b-alert show variant="warning" class="mb-3">
                    <strong>판매가가 {{ 판매현황경과일 }}일 전 값입니다.</strong>
                    쿠팡 판매현황을 마지막으로 수집한 날이 {{ 판매현황기준일 }}입니다.
                    표의 판매가와 그걸로 계산되는 마진·마진율·ROI·최소ROAS는 모두 이 시점 기준이라
                    지금 쿠팡 가격과 다를 수 있습니다.
                    쿠플러스 확장 프로그램에서 쿠팡(supplier)에 로그인된 상태로 수집을 다시 실행해주세요.
                </b-alert>
            </div>

            <!-- 필터 버튼 섹션 -->
            <div class="col-lg-12" v-if="showlist">
                <div class="p-3">
                    <div class="row d-flex justify-content-between">
                        <div>
                            <b-button variant="outline-primary" class="mb-1 mr-2" @click="showtotal">
                                전체 <b-badge variant="primary" class="ml-2">{{ total }}</b-badge>
                            </b-button>
                            <b-button variant="outline-secondary" class="mb-1 mr-2" @click="showProductIdChanged" v-b-tooltip.html="productIdChangedTooltip">
                                노출ID변경<b-badge variant="secondary" class="ml-2">{{ 노출ID변경 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-secondary" class="mb-1 mr-2" @click="showPriceChanged" v-b-tooltip.html="priceChangedTooltip">
                                공급가변경<b-badge variant="secondary" class="ml-2">{{ 공급가변경 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-danger" class="mb-1 mr-2" @click="showMatching" v-b-tooltip.html="otherSellersTooltip">
                                타사매칭<b-badge variant="danger" class="ml-2">{{ 타사매칭 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-secondary" class="mb-1 mr-2" @click="showItemLoser">
                                아이템루저<b-badge variant="secondary" class="ml-2">{{ 아이템루저 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-danger" class="mb-1 mr-2" @click="showOrderDisabled">
                                발주불가<b-badge variant="danger" class="ml-2">{{ 발주불가 }}</b-badge>
                            </b-button>
                            <!-- <b-button variant="outline-warning" class="mb-1 mr-2" @click="showNoBarcodes">
                                바코드없음<b-badge variant="warning" class="ml-2">{{ 바코드없음 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-info" class="mb-1 mr-2" @click="showNoCategory">
                                제품분류없음<b-badge variant="info" class="ml-2">{{ 제품분류없음 }}</b-badge>
                            </b-button> -->
                            <b-button variant="outline-secondary" class="mb-1 mr-2" @click="showd">
                                구매정보없음<b-badge variant="secondary" class="ml-2">{{ 구매정보없음 }}</b-badge>
                            </b-button>
                            <b-button variant="outline-success" class="mb-1 mr-2" @click="showe">
                                매입정보없음<b-badge variant="success" class="ml-2">{{ 매입정보없음 }}</b-badge>
                            </b-button>
                            <b-dropdown text="발주가능상태" variant="outline-warning" class="mb-1 mr-2">
                                <b-dropdown-item @click="filterByOrderStatus('all')">전체</b-dropdown-item>
                                <b-dropdown-item v-for="status in 발주가능상태목록" :key="status"
                                    @click="filterByOrderStatus(status)">{{ status }}</b-dropdown-item>
                            </b-dropdown>

                        </div>
                        <div>
                            <button type="button" @click="showVendorNameModal" class="btn btn-outline-info mr-2 mb-3">허용스토어 설정</button>
                            <button type="reset" @click="excelDownFunc" class="btn btn-success mr-2 mb-3">상품DB
                                다운로드</button>
                            <button type="button" class="btn btn-danger mr-2 mb-3"
                                @click="openImportInfoModal">매입정보 관리</button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-12" v-if="showlist">
                <CDataTable
                    storage-key="rocketProductManagement.1" :headers="headers" :items="productLists" v-model="tableSelectedItem" :show-select="true"
                    :fixedColumns="'상품명'" itemKey="_id" style="margin-bottom: 10px">
                    <template v-slot:이미지="{ item }">
                        <div class="d-flex align-items-center" v-b-modal="'modalpurchase' + item._id">
                            <img :src="item.썸네일" class="img-fluid rounded avatar-50 mr-3" alt="image">
                        </div>
                    </template>
                    <template v-slot:상품명="{ item }">
                        <div>{{ item.상품명 }}</div>
                    </template>

                    <template v-slot:SKUID="{ item }">
                        <div>{{ item.SKUID }}</div>
                    </template>

                    <template v-slot:바코드="{ item }">
                        <div>{{ item.바코드 }}</div>
                    </template>

                    <template v-slot:노출ID="{ item }">
                        <div>
                            {{ item.노출ID || extractProductId(item.판매링크) }}
                            <span v-if="item.productIdHistory && item.productIdHistory.length > 0"
                                style="margin-left: 4px; color: #dc3545; font-size: 12px;"
                                title="노출ID 변경 이력 있음">🔄</span>
                        </div>
                    </template>

                    <template v-slot:옵션ID="{ item }">
                        <div>{{ item.옵션ID || extractVendorItemId(item.판매링크) }}</div>
                    </template>

                    <template v-slot:판매링크="{ item }">
                        <div v-if="item.판매링크">
                            <a :href="item.판매링크" target="_blank">
                                <b-icon icon="link" scale="2" variant="primary"></b-icon>
                            </a>
                        </div>
                    </template>

                    <template v-slot:발주가능상태="{ item }">
                        <b-badge :variant="item.발주가능상태 === '발주가능' || item.발주가능상태 === '정상' ? 'success' : 'danger'">
                            {{ item.발주가능상태 }}
                        </b-badge>
                    </template>

                    <template v-slot:재고="{ item }">
                        <div>{{ item.재고 || '-' }}</div>
                    </template>

                    <template v-slot:판매가="{ item }">
                        <div :class="판매가낡음(item) ? 'text-danger' : ''">
                            {{ item.판매가 ? item.판매가.toLocaleString() + '원' : '-' }}
                        </div>
                        <div v-if="item.판매가 && item.판매가기준일"
                            style="font-size: 11px; line-height: 1.2;"
                            :class="판매가낡음(item) ? 'text-danger' : 'text-muted'"
                            :title="판매가기준일툴팁(item)">
                            {{ 판매가기준일표시(item) }}
                        </div>
                    </template>

                    <template v-slot:공급가="{ item }">
                        <div>
                            {{ item.공급가 ? item.공급가.toLocaleString() + '원' : '-' }}
                            <span v-if="item.priceHistory && item.priceHistory.length > 0"
                                style="margin-left: 4px; color: #dc3545; font-size: 12px;"
                                :title="priceHistoryTitle(item)">🔄</span>
                        </div>
                    </template>

                    <template v-slot:리뷰평점="{ item }">
                        <div v-if="item.리뷰평점">
                            <b-badge variant="warning">{{ item.리뷰평점 }}★</b-badge>
                        </div>
                        <div v-else>-</div>
                    </template>

                    <template v-slot:리뷰수="{ item }">
                        <div>{{ item.리뷰수 || '-' }}</div>
                    </template>

                    <template v-slot:구매정보="{ item }">
                        <b-icon v-b-modal="'modalpurchase' + item._id" icon="cart-check" scale="2"
                            :variant="classPurchaseInfo(item)"></b-icon>

                        <b-modal :id="'modalpurchase' + item._id" size="xl" title="구매정보" ok-title="저장" cancel-title="취소"
                            @ok="savePurchaseInfo($event, item)" @cancel="cancelPurchaseInfo($event, item)">
                            <div>{{ item.상품명 }}</div>
                            <div class="row" v-if="showPurchase">
                                <div class="col-12">
                                    <div class="table-responsive">
                                        <table id="datatable" class="table data-table table-striped dataTable">
                                            <thead>
                                                <tr class="ligth ligth-data">
                                                    <th style="min-width:200px;font-size:90%">제품정보</th>
                                                    <th style="font-size:90%">상품매칭</th>
                                                    <th style="max-width:300px;overflow:hidden;text-overflow: ellipsis;font-size:90%">구매링크</th>
                                                    <th style="font-size:90%">옵션1_중국어</th>
                                                    <th style="font-size:90%">옵션2_중국어</th>
                                                    <th style="font-size:90%">구성수량</th>
                                                    <th style="font-size:90%">기본요청사항</th>
                                                    <th style="font-size:90%">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(list, idx1) in item.구매정보" :key="idx1" class="tableTr">
                                                    <td style="min-width:200px;font-size:90%">
                                                        <div class="d-flex align-items-center">
                                                            <img :src="list.등록이미지" class="img-fluid rounded avatar-80 mr-3" alt="image" v-if="list.등록이미지">
                                                            <div v-if="list.상품명">
                                                                {{ list.상품명 }}
                                                                <p class="mb-0"><small>{{ list.바코드 }}</small></p>
                                                            </div>
                                                            <div v-else>
                                                                <input type="text" class="form-control" placeholder="상품명입력" v-model="list.상품명init" @change="addProductName(list)">
                                                                <p class="mb-0"><small>{{ list.바코드 }}</small></p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style="font-size:90%">
                                                        <div :class="matchclass(list.매칭상태)">{{ list.매칭상태 }}</div>
                                                    </td>
                                                    <td style="max-width:300px;overflow:hidden;text-overflow: ellipsis;font-size:90%">
                                                        <div v-if="list.구매링크 !== undefined">
                                                            <a :href="list.구매링크" target="_blank">{{ list.구매링크 }}</a>
                                                            <div v-if="list.showspinner">
                                                                <img style="width:20%;" :src="require('../../../assets/images/small/loading.gif')">
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <input type="text" class="form-control" placeholder="구매링크입력" v-model="list.구매링크init" @change="matchoption1(item.구매정보, idx1, list.구매링크init)">
                                                        </div>
                                                    </td>
                                                    <td style="font-size:90%">
                                                        <div v-if="list.옵션이미지 !== undefined">
                                                            <img :src="list.옵션이미지" class="img-fluid rounded avatar-80 mr-3" alt="image">
                                                        </div>
                                                        <div v-if="list.옵션1_중국어 !== undefined">
                                                            {{ list.옵션1_중국어 }}
                                                        </div>
                                                        <div v-else>
                                                            <b-dropdown menu-class="my-dropdown-class" size="lg"
                                                                variant="link" toggle-class="text-decoration-none"
                                                                no-caret>
                                                                <template #button-content>
                                                                    &#x1f50d;<span class="sr-only">Search</span>
                                                                </template>
                                                                <b-dropdown-item href="#"
                                                                    v-for="a, i in list.상품매칭.옵션1_중국어" :key="i"
                                                                    @click="option1matching(a, list)">
                                                                    <div class="d-flex align-items-center">
                                                                        <img v-if="a.imageUrl && a.imageUrl.length > 0"
                                                                            :src="a.imageUrl"
                                                                            class="img-fluid rounded avatar-80 mr-3"
                                                                            alt="image">
                                                                        <div>
                                                                            {{ a.name }}
                                                                        </div>
                                                                    </div>
                                                                </b-dropdown-item>
                                                            </b-dropdown>
                                                        </div>
                                                    </td>
                                                    <td style="font-size:90%">
                                                        <div v-if="list.옵션2_중국어 !== undefined">
                                                            {{ list.옵션2_중국어 }}
                                                        </div>
                                                        <div v-else>
                                                            <b-dropdown menu-class="my-dropdown-class" size="lg"
                                                                variant="link" toggle-class="text-decoration-none"
                                                                no-caret>
                                                                <template #button-content>
                                                                    &#x1f50d;<span class="sr-only">Search</span>
                                                                </template>
                                                                <b-dropdown-item href="#"
                                                                    v-for="a, i in list.상품매칭.옵션2_중국어" :key="i"
                                                                    @click="option2matching(a, list)">
                                                                    <div class="d-flex align-items-center">
                                                                        <img v-if="a.imageUrl && a.imageUrl.length > 0"
                                                                            :src="a.imageUrl"
                                                                            class="img-fluid rounded avatar-80 mr-3"
                                                                            alt="image">
                                                                        <div>
                                                                            {{ a.name }}
                                                                        </div>
                                                                    </div>
                                                                </b-dropdown-item>
                                                            </b-dropdown>
                                                        </div>
                                                    </td>
                                                    <td style="font-size:90%">
                                                        <div v-if="!editQty" @click="editQty = true">
                                                            {{ list.판매구성수량 }}
                                                        </div>
                                                        <div v-else>
                                                            <input type="number" :min="0" class="form-control"
                                                                placeholder="" aria-label="" v-model="list.판매구성수량"
                                                                style="text-align:center;"
                                                                v-b-tooltip.left="'해당 SKU가 2p 구성일 경우에는 2라고 작성해 주세요'"
                                                                @keyup.enter="editQtyEnter" @change="editQty = false">
                                                        </div>
                                                    </td>
                                                    <td style="font-size:90%">
                                                        <div :class="reqclass(list.요청사항)" v-b-modal="'modalreq' + idx1"
                                                            v-if="idx1 == 0">{{ list.요청사항 }}</div>
                                                        <b-modal modal-class="reqpo-modal-scrollable"
                                                            :id="'modalreq' + idx1" size="xl" title="구매요청사항"
                                                            ok-title="요청내용저장" cancel-title="취소"
                                                            @ok="savereq($event, list, idx1)">
                                                            <div class="reqpo-purchase-request-form">
                                                                <div class="row">
                                                                    <!-- Row 1: Items 1-2 -->
                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">1. 구매요청수량
                                                                            </div>
                                                                            <div class="reqpo-input-wrapper">
                                                                                <div class="d-flex align-items-center">
                                                                                    <input type="number" :min="0"
                                                                                        class="form-control text-center"
                                                                                        style="width: 120px;"
                                                                                        v-model="list.구매요청수량"
                                                                                        @keyup.enter="validateQuantity(list)">
                                                                                    <div class="reqpo-stock-info ml-3">
                                                                                        <span
                                                                                            class="reqpo-info-label">최소주문:</span>
                                                                                        <span
                                                                                            class="reqpo-info-value">{{
                                                                                            getMinOrderQuantity(list)
                                                                                            }}개</span>
                                                                                        <span
                                                                                            class="reqpo-separator">/</span>
                                                                                        <span
                                                                                            class="reqpo-info-label">재고:</span>
                                                                                        <span
                                                                                            class="reqpo-info-value">{{
                                                                                            getAvailableStock(list)
                                                                                            }}개</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">2. 판매구성수량
                                                                            </div>
                                                                            <div class="reqpo-input-wrapper">
                                                                                <input type="number" :min="0"
                                                                                    class="form-control"
                                                                                    style="width: 120px;"
                                                                                    v-model="list.판매구성수량"
                                                                                    v-b-tooltip.hover="'해당 SKU가 2p 구성일 경우에는 2라고 작성해 주세요'">
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                    <!-- Row 2: Items 3-4 -->
                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">3. A-B번들
                                                                                묶음구성여부</div>
                                                                            <div class="bundle-options">
                                                                                <div
                                                                                    class="custom-control custom-switch d-inline-block">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'bundleSwitch' + idx1"
                                                                                        v-model="list.묶음구성여부"
                                                                                        @change="confirmBarcode(list)">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'bundleSwitch' + idx1">묶음구성</label>
                                                                                </div>
                                                                                <div v-if="list.묶음구성여부"
                                                                                    class="bundle-count mt-2">
                                                                                    <input type="number" :min="0"
                                                                                        class="form-control"
                                                                                        style="width: 120px;"
                                                                                        placeholder="종류갯수"
                                                                                        v-model="list.묶음구성수량"
                                                                                        v-b-tooltip.hover="'3종의 제품을 묶음 구성하는 경우 3으로 작성'">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">4. 도착지 및 출고형태
                                                                            </div>
                                                                            <div class="destination-options">
                                                                                <div class="btn-group-vertical w-100">
                                                                                    <button type="button" class="btn mb-1"
                                                                                        :class="{ 'btn-primary': list.요청내역.deliveryType === 'coupang-shipment', 'btn-outline-primary': list.요청내역.deliveryType !== 'coupang-shipment' }"
                                                                                        @click="list.요청내역.deliveryType = 'coupang-shipment'; list.요청내역.destination = 'coupang'; list.요청내역.exportType = 'box'">
                                                                                        쿠팡 쉽먼트택배
                                                                                    </button>
                                                                                    <button type="button" class="btn mb-1"
                                                                                        :class="{ 'btn-primary': list.요청내역.deliveryType === 'customer-box', 'btn-outline-primary': list.요청내역.deliveryType !== 'customer-box' }"
                                                                                        @click="list.요청내역.deliveryType = 'customer-box'; list.요청내역.destination = 'customer'; list.요청내역.exportType = 'box'">
                                                                                        화주 택배
                                                                                    </button>
                                                                                    <button type="button" class="btn mb-1"
                                                                                        :class="{ 'btn-primary': list.요청내역.deliveryType === 'customer-pallet', 'btn-outline-primary': list.요청내역.deliveryType !== 'customer-pallet' }"
                                                                                        @click="list.요청내역.deliveryType = 'customer-pallet'; list.요청내역.destination = 'customer'; list.요청내역.exportType = 'pallet'">
                                                                                        화주 파렛트 <small
                                                                                            class="reqpo-text-muted">(￦20,000/pallet)</small>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <!-- Row 3: Items 5-7 -->
                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">6. 통관정보
                                                                            </div>
                                                                            <div class="row">
                                                                                <div class="col-12 mb-3">
                                                                                    <div class="form-group">
                                                                                        <label>신고영문명</label>
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) shoes"
                                                                                            v-model="list.신고영문명">
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-12">
                                                                                    <div class="form-group">
                                                                                        <label>HS-CODE</label>
                                                                                        <div class="d-flex">
                                                                                            <input type="text"
                                                                                                class="form-control"
                                                                                                placeholder="예) 6401.10-1000"
                                                                                                v-model="list.HSCODE">
                                                                                            <div
                                                                                                class="w-25 d-flex align-items-center">
                                                                                                <a href="https://www.bandtrass.or.kr/hsnavi.do"
                                                                                                    target="_blank"
                                                                                                    class="btn btn-outline-secondary ml-2">
                                                                                                    검색
                                                                                                </a></div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-6">
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">7. 통관형태
                                                                            </div>
                                                                            <div class="customs-options">
                                                                                <div class="reqpo-custom-radio-card mb-2"
                                                                                    :class="{ 'active': list.요청내역.customsType === 'integrated' }"
                                                                                    @click="list.요청내역.customsType = 'integrated'">
                                                                                    <div class="reqpo-card-title">
                                                                                        쿠패스통합통관</div>
                                                                                    <div class="reqpo-card-desc">
                                                                                        위안화x280, 검수/포장비용 제외 모든비용 포함
                                                                                    </div>
                                                                                </div>
                                                                                <div class="reqpo-custom-radio-card mb-2"
                                                                                    :class="{ 'active': list.요청내역.customsType === 'client' }"
                                                                                    @click="list.요청내역.customsType = 'client'">
                                                                                    <div class="reqpo-card-title">화주단독통관
                                                                                    </div>
                                                                                    <div class="reqpo-card-desc">
                                                                                        구매대행수수료3%, 자재, 관부가세, 해운비, 통관비,
                                                                                        통관서류 비용 등 별도</div>
                                                                                </div>
                                                                                <div class="reqpo-custom-radio-card"
                                                                                    :class="{ 'active': list.요청내역.customsType === 'kupass' }"
                                                                                    @click="list.요청내역.customsType = 'kupass'">
                                                                                    <div class="reqpo-card-title">
                                                                                        쿠패스단독통관</div>
                                                                                    <div class="reqpo-card-desc">식검제품만
                                                                                        신청가능, 구매대행수수료3%, 자재, 관부가세, 해운비,
                                                                                        통관비, 통관서류 비용 등 별도
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <!-- Full width sections -->
                                                                    <div class="col-md-6">
                                                                        <!-- 검수 및 포장 섹션 -->
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">8. 검수 및 포장
                                                                            </div>
                                                                            <div class="inspection-options">

                                                                                <!-- 패키징 옵션 -->
                                                                                <div v-if="list.요청내역.default"
                                                                                    class="packaging-options mb-3">
                                                                                    <div
                                                                                        class="reqpo-option-title mb-2">
                                                                                        포장 방법 선택:</div>
                                                                                    <div
                                                                                        class="custom-control custom-radio mb-2">
                                                                                        <input type="radio"
                                                                                            :id="'packageAuto' + idx1"
                                                                                            name="packageMethod"
                                                                                            class="custom-control-input"
                                                                                            value="auto"
                                                                                            v-model="packageMethod"
                                                                                            @change="changePackage(list)">
                                                                                        <label
                                                                                            class="custom-control-label"
                                                                                            :for="'packageAuto' + idx1">
                                                                                            포장 방법 위임
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        class="custom-control custom-radio mb-2">
                                                                                        <input type="radio"
                                                                                            :id="'packageNo' + idx1"
                                                                                            name="packageMethod"
                                                                                            class="custom-control-input"
                                                                                            value="noPackage"
                                                                                            v-model="packageMethod"
                                                                                            @change="changePackage(list)">
                                                                                        <label
                                                                                            class="custom-control-label"
                                                                                            :for="'packageNo' + idx1">
                                                                                            재포장 생략
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        class="custom-control custom-radio mb-2">
                                                                                        <input type="radio"
                                                                                            :id="'packageOPP' + idx1"
                                                                                            name="packageMethod"
                                                                                            class="custom-control-input"
                                                                                            value="opp"
                                                                                            v-model="packageMethod"
                                                                                            @change="changePackage(list)">
                                                                                        <label
                                                                                            class="custom-control-label"
                                                                                            :for="'packageOPP' + idx1">
                                                                                            투명 OPP 봉투 포장 (무료)
                                                                                        </label>
                                                                                    </div>
                                                                                    <div
                                                                                        class="custom-control custom-radio">
                                                                                        <input type="radio"
                                                                                            :id="'packageLDPE' + idx1"
                                                                                            name="packageMethod"
                                                                                            class="custom-control-input"
                                                                                            value="LDPE"
                                                                                            v-model="packageMethod"
                                                                                            @change="changePackage(list)">
                                                                                        <label
                                                                                            class="custom-control-label"
                                                                                            :for="'packageLDPE' + idx1">
                                                                                            불투명 LDPE 봉투 포장 (무료)
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div class="reqpo-option-group mb-3">
                                                                                <div
                                                                                    class="custom-control custom-switch">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'defaultCheck' + idx1"
                                                                                        v-model="list.요청내역.default">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'defaultCheck' + idx1">
                                                                                        기본검수/분류/포장/포장자재 (￦200)
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            <!-- 라벨링 옵션 -->
                                                                            <div class="labeling-options mb-3">
                                                                                <div
                                                                                    class="custom-control custom-switch mb-2">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'barcodeCheck' + idx1"
                                                                                        v-model="list.요청내역.barcode"
                                                                                        @change="changeBarcode(list)">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'barcodeCheck' + idx1">
                                                                                        바코드라벨 (Made in China,한글표시사항
                                                                                        기본포함) (￦100)
                                                                                    </label>
                                                                                </div>

                                                                                <div v-if="!list.요청내역.barcode"
                                                                                    class="custom-control custom-switch">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'stickerCheck' + idx1"
                                                                                        v-model="list.요청내역.sticker">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'stickerCheck' + idx1">
                                                                                        원산지스티커 (￦100)
                                                                                    </label>
                                                                                </div>
                                                                            </div>

                                                                            <!-- 추가 작업 옵션 -->
                                                                            <div class="additional-options">
                                                                                <div
                                                                                    class="custom-control custom-switch mb-2">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'maskingCheck' + idx1"
                                                                                        v-model="list.요청내역.masking">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'maskingCheck' + idx1">
                                                                                        중국어 마스킹 (무료)
                                                                                    </label>
                                                                                </div>

                                                                                <div
                                                                                    class="custom-control custom-switch mb-2">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'airpackingCheck' + idx1"
                                                                                        v-model="list.요청내역.airpacking">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'airpackingCheck' + idx1">
                                                                                        에어캡 포장 (실비)
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    class="custom-control custom-switch mb-2">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'sewingCheck' + idx1"
                                                                                        v-model="list.요청내역.sewing">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'sewingCheck' + idx1">
                                                                                        원산지라벨 봉제 (6000원/시간)
                                                                                    </label>
                                                                                    <div class="reqpo-warning-text">* 의류
                                                                                        수입 시 원산지 라벨봉제는 필수 사항입니다.</div>
                                                                                </div>

                                                                                <div
                                                                                    class="custom-control custom-switch mb-2">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'stampCheck' + idx1"
                                                                                        v-model="list.요청내역.stamp">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'stampCheck' + idx1">
                                                                                        원산지 도장 (6000원/시간)
                                                                                    </label>
                                                                                    <div class="reqpo-warning-text">*
                                                                                        신발류 수입 시 제품에 원산지 라벨봉제 또는 원산지 도장은
                                                                                        필수 사항입니다.</div>
                                                                                </div>

                                                                                <div
                                                                                    class="custom-control custom-switch">
                                                                                    <input type="checkbox"
                                                                                        class="custom-control-input"
                                                                                        :id="'tagCheck' + idx1"
                                                                                        v-model="list.요청내역.tag">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'tagCheck' + idx1">
                                                                                        원산지 택(태그) (6000원/시간)
                                                                                    </label>
                                                                                    <div class="reqpo-warning-text">*
                                                                                        가방류 수입 시 원산지 라벨봉제 또는 원산지 택 표기가
                                                                                        필수 사항입니다.</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <!-- 기존 판매자 협의 금액 섹션 -->
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">10. 기존 판매자
                                                                                협의 금액 (선택)</div>
                                                                            <div class="price-info-form">
                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-4 col-form-label">협의단가(CNY)</label>
                                                                                    <div class="col-sm-8">
                                                                                        <input type="number" :min="0"
                                                                                            class="form-control"
                                                                                            v-model="list.협의단가">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-4 col-form-label">
                                                                                        총금액(CNY)<br>
                                                                                        <small>(중국 내륙배송비 포함 전체
                                                                                            결제금액)</small>
                                                                                    </label>
                                                                                    <div class="col-sm-8">
                                                                                        <input type="number" :min="0"
                                                                                            class="form-control"
                                                                                            v-model="list.협의총금액">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-4 col-form-label">협의1688
                                                                                        ID</label>
                                                                                    <div class="col-sm-8">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            v-model="list.협의ID">
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">
                                                                                <div>기타요청사항 - 물류요청사항</div>
                                                                                <small class="reqpo-text-muted ml-3">
                                                                                    (예: 1688제품 겉박스 중국어 있는부분 작업 요청 내용,
                                                                                    실사,
                                                                                    사이즈, 무게, 센터 입고요청, 신발도장, 의류봉제 등,
                                                                                    OPP/LDPE/뽁뽁이 일반검수/정밀검수, 시간이 걸리는 별도의
                                                                                    작업은
                                                                                    6000/시간의 작업비 발생)
                                                                                </small>
                                                                            </div>
                                                                            <textarea class="form-control mt-3" rows="3"
                                                                                v-model="list.요청내역.reqcontent">
                                                                            </textarea>
                                                                        </div>
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">
                                                                                <div>기타요청사항 - 구매요청사항</div>
                                                                            </div>
                                                                            <textarea class="form-control mt-3" rows="3"
                                                                                v-model="list.요청내역.reqcontentPurchase">
                                                                            </textarea>
                                                                        </div>

                                                                    </div>


                                                                    <div class="col-md-6">

                                                                        <!-- 한글표시사항 섹션 -->
                                                                        <div class="reqpo-form-section">
                                                                            <div class="reqpo-section-title">9. 한글표시사항
                                                                            </div>

                                                                            <!-- 바코드라벨 미부착 시 경고 -->
                                                                            <div v-if="!list.요청내역.barcode"
                                                                                class="reqpo-warning-box mb-3">
                                                                                <div class="warning-content">
                                                                                    <div class="warning-title">※ 바코드라벨을
                                                                                        부착하지 않는 경우,</div>
                                                                                    <div class="reqpo-warning-text"
                                                                                        v-if="list.요청내역.destination === 'coupang'">
                                                                                        쿠팡센터 직납 시 사전에 제품패키지 겉에 반드시 바코드가
                                                                                        부착되거나 새겨져 있어야 합니다.
                                                                                    </div>
                                                                                    <div class="reqpo-warning-text"
                                                                                        v-if="list.요청내역.destination === 'customer'">
                                                                                        반드시 원산지표시가 되어 있어야 합니다.
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <!-- 한글표시사항 입력 폼 -->
                                                                            <div v-if="list.요청내역.barcode"
                                                                                class="korean-label-form">
                                                                                <!-- 바코드 -->
                                                                                <div class="form-group">
                                                                                    <label
                                                                                        class="col-form-label">바코드번호</label>
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) S00012341234"
                                                                                        v-model="list.바코드">
                                                                                    <small class="reqpo-warning-text">*
                                                                                        바코드는 쿠팡에 등록한 바코드번호를
                                                                                        입력해주세요</small>
                                                                                </div>

                                                                                <!-- 제품명 (별도 상단 배치) -->
                                                                                <div class="form-group">
                                                                                    <label>제품명</label>
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) 쿠플러스 예쁜접시, 10인치"
                                                                                        v-model="list.상품명">
                                                                                    <small class="reqpo-warning-text">*
                                                                                        쿠팡에 등록한 상품명 + 옵션명을 같이
                                                                                        입력해주세요</small>
                                                                                </div>

                                                                                <!-- 기타 한글표시사항 -->
                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">수입원/판매원</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 쿠플러스"
                                                                                            v-model="list.한글표시사항['수입원/판매원']">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">제조원</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 중국OEM"
                                                                                            v-model="list.한글표시사항.제조원">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">제조국</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 중국"
                                                                                            v-model="list.한글표시사항.제조국">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">내용량</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 300ml"
                                                                                            v-model="list.한글표시사항.내용량">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">원료명및성분명(재질)</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 도자기제"
                                                                                            v-model="list.한글표시사항['원료명및성분명(재질)']">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">상품유형</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 주방용품"
                                                                                            v-model="list.한글표시사항.상품유형">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">사용시주의사항</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 용도 이외에 사용금지"
                                                                                            v-model="list.한글표시사항.사용시주의사항">
                                                                                    </div>
                                                                                </div>

                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">사용기준</label>
                                                                                    <div class="col-sm-9">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 14세 이상"
                                                                                            v-model="list.한글표시사항.사용기준">
                                                                                    </div>
                                                                                </div>

                                                                                <!-- KC인증 / 식품용 옵션 -->
                                                                                <div class="form-group row">
                                                                                    <label class="col-sm-3 col-form-label">바코드 옵션</label>
                                                                                    <div class="col-sm-9">
                                                                                        <div class="custom-control custom-switch mb-2">
                                                                                            <input type="checkbox"
                                                                                                class="custom-control-input"
                                                                                                :id="'kcCheck' + idx1"
                                                                                                v-model="list.한글표시사항.kc인증">
                                                                                            <label class="custom-control-label"
                                                                                                :for="'kcCheck' + idx1">
                                                                                                KC인증마크 표시
                                                                                            </label>
                                                                                        </div>
                                                                                        <div class="custom-control custom-switch">
                                                                                            <input type="checkbox"
                                                                                                class="custom-control-input"
                                                                                                :id="'foodCheck' + idx1"
                                                                                                v-model="list.한글표시사항.식품용">
                                                                                            <label class="custom-control-label"
                                                                                                :for="'foodCheck' + idx1">
                                                                                                식품용 (식품위생법에 의한 한글표시사항)
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <!-- 기타 표시사항 -->
                                                                                <div class="form-group row">
                                                                                    <label
                                                                                        class="col-sm-3 col-form-label">기타</label>
                                                                                    <div class="col-sm-9">
                                                                                        <textarea class="form-control"
                                                                                            rows="2"
                                                                                            placeholder="기타 표시사항"
                                                                                            v-model="list.한글표시사항.custom"></textarea>
                                                                                    </div>
                                                                                </div>

                                                                                <!-- 바코드 출력 버튼 -->
                                                                                <div class="mt-2">
                                                                                    <b-button variant="outline-success" size="sm"
                                                                                        @click="printBarcodeFromPurchase(list, item)">
                                                                                        <i class="ri-printer-line mr-1"></i>바코드 출력
                                                                                    </b-button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </b-modal>
                                                    </td>
                                                    <td style="font-size:90%">
                                                        <div class="d-flex justify-content-center list-action">
                                                            <a class="badge bg-success mr-2" data-toggle="tooltip"
                                                                v-b-tooltip.top title="옵션재매칭" href="javascript:void(0)"
                                                                @click="rematching(item.구매정보, list, idx1)">
                                                                <i class="ri-pencil-line mr-0"></i>
                                                            </a>
                                                            <a class="badge badge-secondary mr-2" data-toggle="tooltip"
                                                                v-b-tooltip.top title="Reset" href="javascript:void(0)"
                                                                @click="reset(list)">
                                                                <i class="ri-eye-line mr-0"></i>
                                                            </a>
                                                            <a class="badge bg-warning mr-2" data-toggle="tooltip"
                                                                v-b-tooltip.top title="삭제" href="javascript:void(0)"
                                                                @click="deletePurchaseInfo(item, idx1)">
                                                                <i class="ri-delete-bin-line mr-0"></i>
                                                            </a>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="8">
                                                        <div class="d-flex justify-content-start mt-2 mb-2">
                                                            <b-button @click="addPurchaseInfo(item)" variant="outline-primary" class="text-center">+ 추가</b-button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-12 mb-0">
                                    <b-button @click="copyReq(item.구매정보)" variant="outline-primary"
                                        class="text-center">+ 묶음구성추가</b-button>
                                </div>
                            </div>
                        </b-modal>
                    </template>

                    <template v-slot:매입가="{ item }">
                        <b-button v-if="item.latestImportPrice > 0" variant="outline-success" class="mb-1 mr-2"
                            v-b-modal="'modalImport' + item._id">{{ item.latestImportPrice | currency }}</b-button>
                        <b-button v-else variant="outline-secondary" class="mb-1 mr-2"
                            v-b-modal="'modalImport' + item._id">입력</b-button>

                        <b-modal :id="'modalImport' + item._id" size="md" title="매입정보" ok-title="저장" cancel-title="취소"
                            @ok="saveImport($event, item)">
                            <p>매입가는 부가세가 포함된 전체 매입가로 입력해 주세요</p>
                            <div class="row" v-if="showImport">
                                <div class="col-md-12">
                                    <div class="table-responsive">
                                        <table id="datatable"
                                            class="table data-table table-striped dataTable text-center"
                                            style="font-size:90%">
                                            <thead>
                                                <tr class="ligth ligth-data">
                                                    <th style="font-size:90%">Date</th>
                                                    <th style="font-size:90%">매입가</th>
                                                    <th style="font-size:90%">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(list, idx) in item.매입정보" :key="idx">
                                                    <td>
                                                        <div v-if="!editmode">
                                                            {{ list.date }}
                                                        </div>
                                                        <div v-else>
                                                            <input type="date" class="form-control ml-1 text-center"
                                                                v-model="list.date"
                                                                @keyup.enter="changeImportInfo($event)">
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div v-if="!editmode">
                                                            {{ list.매입가 }}
                                                        </div>
                                                        <div v-else>
                                                            <input type="number" class="form-control ml-1 text-center"
                                                                v-model="list.매입가"
                                                                @keyup.enter="changeImportInfo($event)">
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <!-- <a class="badge badge-secondary mr-2" data-toggle="tooltip" v-b-tooltip.top title="Edit" href="javascript:void(0)" @click="editImport()">
                                                            <i class="ri-eye-line mr-0"></i>
                                                        </a> -->
                                                        <a class="badge bg-warning mr-2" data-toggle="tooltip"
                                                            v-b-tooltip.top title="Delete" href="javascript:void(0)"
                                                            @click="deleteImport(item, idx)">
                                                            <i class="ri-delete-bin-line mr-0"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <div class="d-flex justify-content-start mt-2 ml-4 mb-2">
                                                        <b-button @click="addImportInfo(item)" variant="outline-primary"
                                                            class="text-center">+ 추가</b-button>
                                                        <b-button @click="editImport()" variant="outline-secondary"
                                                            class="text-center ml-2">편집</b-button>
                                                    </div>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- <div class="d-flex justify-content-between">
                                        <button type="button" class="btn btn-success mr-2 mb-4" @click="resetAutoList">전체삭제</button>
                                        <button type="button" class="btn btn-primary mr-2 mb-4" @click="collectAll">전체수집</button>
                                    </div> -->
                                </div>
                            </div>
                        </b-modal>
                    </template>

                    <template v-slot:마진="{ item }">
                        <div v-if="item.마진 > 0">
                            {{ item.마진.toFixed(0).toLocaleString() }}원
                        </div>
                        <div v-else>-</div>
                    </template>

                    <template v-slot:마진율="{ item }">
                        <div v-if="item.마진율 > 0">
                            <b-badge :variant="getMarginVariant(item)">
                                {{ item.마진율.toFixed(1) }}%
                            </b-badge>
                        </div>
                        <div v-else>-</div>
                    </template>

                    <template v-slot:ROI="{ item }">
                        <div v-if="item.ROI > 0">
                            <b-badge :variant="getROIVariant(item)">
                                {{ item.ROI.toFixed(0) }}%
                            </b-badge>
                        </div>
                        <div v-else>-</div>
                    </template>

                    <template v-slot:최소ROAS="{ item }">
                        <div v-if="item.최소ROAS > 0">
                            <b-badge variant="secondary">
                                {{ (item.최소ROAS*100).toFixed(0) }}%
                            </b-badge>
                        </div>
                        <div v-else>-</div>
                    </template>

                    <template v-slot:쿠팡마진="{ item }">
                        <div v-if="item.쿠팡마진 > 0">
                            {{ item.쿠팡마진.toLocaleString() }}원
                        </div>
                        <div v-else>-</div>
                    </template>

                    <template v-slot:쿠팡마진율="{ item }">
                        <div v-if="item.쿠팡마진율 > 0">
                            <b-badge :variant="getCoupangMarginVariant(item)">
                                {{ item.쿠팡마진율.toFixed(1) }}%
                            </b-badge>
                        </div>
                        <div v-else>-</div>
                    </template>

                    <template v-slot:바코드출력="{ item }">
                        <b-button variant="outline-primary text-center" size="sm" @click="printSingleBarcode(item)">
                            <i class="fa fa-print text-center"></i>
                        </b-button>
                    </template>

                </CDataTable>

                <!-- 개별 바코드 출력용 숨겨진 템플릿 -->
                <div class="mb-4 ml-1 d-none" id="printSingleBarcode">
                    <div v-for="index in parseInt(출력수량)" :key="index">
                        <div class="row d-flex justify-content-center ml-1" :style="barcodegap(index, parseInt(출력수량))">
                            <div class="col-12 d-flex flex-left mb-0" style="margin-top:0px;margin-bottom:0px;margin-left:10px;margin-right:10px;display:flex;justify-content: space-between;">
                                <div class="mb-0" style="font-size:90%;color:black;">{{원산지}}</div>
                                <div :style="printsku">SKU : {{출력SKUID}}</div>
                            </div>
                            <div class="col-12 text-center d-flex justify-content-center mt-0 mb-0" style="margin-top:0px;margin-bottom:0px">
                                <barcode :value="출력바코드" :tag="bctag" height="50" :options="{ lineColor: '#0275d8', text: 'Scan', margin : 0}"></barcode>
                            </div>
                            <div v-if="printfoodenable" style="width:100%;margin-top:0px;margin-bottom:0px;margin-left:10px;font-size:80%;">
                                <span style="font-size:80%;color:black;display:block">{{출력상품명}}</span>
                                <div style="font-size:90%;font-weight:bold">식품위생법에 의한 한글표시사항</div>
                            </div>
                            <div class="col-12 mt-0 mb-0" style="margin-top:0px;margin-bottom:0px;margin-left:10px;margin-right:10px;text-align:left;line-height:5px;">
                                <span v-if="!printfoodenable" :style="disablekr">{{출력상품명}}</span><br>
                                <span :style="enablekr">1. 상품명 : {{출력상품명}}</span><br>
                                <span :style="enablekr">2. 수입원/판매원 : {{한글표시사항['수입원/판매원']}}</span><br>
                                <span :style="enablekr">3. 제조원 : {{한글표시사항.제조원}}</span><br>
                                <span :style="enablekr">4. 제조국 : {{한글표시사항.제조국}}</span><br>
                                <span :style="enablekr">5. 내용량 : {{한글표시사항.내용량}}</span><br>
                                <span :style="enablekr">6. 원료명및성분명(재질) : {{한글표시사항['원료명및성분명(재질)']}}</span><br>
                                <div style="display: flex;justify-content: space-between;">
                                    <div>
                                        <span :style="enablekr">7. 상품유형 : {{한글표시사항.상품유형}}</span><br>
                                        <span :style="enablekr">8. 사용시주의사항 : {{한글표시사항.사용시주의사항}}</span><br>
                                        <span :style="enablekr">9. 사용기준 : {{한글표시사항.사용기준}}</span><br>
                                        <span v-if="한글표시사항.custom" :style="enablekr">10. {{한글표시사항.custom}}</span><br v-if="한글표시사항.custom">
                                    </div>
                                    <div style="height:60px;margin-right:10px;margin-top:10px;margin-left:10px;">
                                        <img v-if="printfoodenable" style="height:100%" :src="require('../../../assets/images/small/ForFood.png')">
                                        <img v-if="printkcenable" style="height:100%" :src="require('../../../assets/images/small/KcMark.jpg')">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            
            <!-- 바코드 출력용 숨겨진 영역 -->
            <div class="mb-4 ml-1 d-none" id="printMe8">
                <div v-for="index in parseInt(출력수량)" :key="index">
                    <div class="row d-flex justify-content-center ml-1" :style="barcodegap(index, parseInt(출력수량))">
                        <div class="col-12 d-flex flex-left mb-0"
                            style="margin-top:0px;margin-bottom:0px;margin-left:10px;margin-right:10px;display:flex;justify-content: space-between;">
                            <div class="mb-0" style="font-size:90%;color:black;">{{ 원산지 }}</div>
                            <div :style="printsku">SKU : {{ 출력SKUID }}</div>
                        </div>
                        <div class="col-12 text-center d-flex justify-content-center mt-0 mb-0"
                            style="margin-top:0px;margin-bottom:0px">
                            <barcode :value="출력바코드" :tag="bctag" height="50"
                                :options="{ lineColor: '#0275d8', text: 'Scan', margin : 0}"></barcode>
                        </div>
                        <div v-if="printfoodenable" style="width:100%;margin-top:0px;margin-bottom:0px;margin-left:10px;font-size:80%;">
                            <span style="font-size:80%;color:black;display:block">{{ 출력상품명 }}</span>
                            <div style="font-size:90%;font-weight:bold">식품위생법에 의한 한글표시사항</div>
                        </div>
                        <div class="col-12 mt-0 mb-0"
                            style="margin-top:0px;margin-bottom:0px;margin-left:10px;margin-right:10px;text-align:left;line-height:5px;">
                            <span v-if="!printfoodenable" :style="disablekr">{{ 출력상품명 }}</span><br>
                            <span :style="enablekr">1. 상품명 : {{ 출력상품명 }}</span><br>
                            <span :style="enablekr">2. 수입원/판매원 : {{ 한글표시사항['수입원/판매원'] }}</span><br>
                            <span :style="enablekr">3. 제조원 : {{ 한글표시사항.제조원 }}</span><br>
                            <span :style="enablekr">4. 제조국 : {{ 한글표시사항.제조국 }}</span><br>
                            <span :style="enablekr">5. 내용량 : {{ 한글표시사항.내용량 }}</span><br>
                            <span :style="enablekr">6. 원료명및성분명(재질) : {{ 한글표시사항['원료명및성분명(재질)'] }}</span><br>
                            <div style="display: flex;justify-content: space-between;">
                                <div>
                                    <span :style="enablekr">7. 상품유형 : {{ 한글표시사항.상품유형 }}</span><br>
                                    <span :style="enablekr">8. 사용시주의사항 : {{ 한글표시사항.사용시주의사항 }}</span><br>
                                    <span :style="enablekr">9. 사용기준 : {{ 한글표시사항.사용기준 }}</span><br>
                                    <span v-if="한글표시사항.custom" :style="enablekr">10. {{ 한글표시사항.custom }}</span><br v-if="한글표시사항.custom">
                                </div>
                                <div style="height:60px;margin-right:10px;margin-top:10px;margin-left:10px;">
                                    <img v-if="printfoodenable" style="height:100%" :src="require('../../../assets/images/small/ForFood.png')">
                                    <img v-if="printkcenable" style="height:100%" :src="require('../../../assets/images/small/KcMark.jpg')">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>





            <b-modal :id="'addManage'" size="md" title="숨김처리취소" ok-only>
                <button type="reset" @click="importHideProducts" class="btn btn-primary mr-2 mb-3">숨김상품 불러오기</button>
                <div class="row">
                    <img v-if="showspinner2" style="max-width:100%;"
                        :src="require('../../../assets/images/small/spinner.gif')">
                </div>
                <div class="row" v-if="showHideProducts">
                    <div class="col-12 mt-3">
                        <div class="table-responsive">
                            <table class="table data-table table-striped dataTable">
                                <thead>
                                    <tr class="ligth ligth-data">
                                        <th style="min-width:200px;font-size:90%">제품정보</th>
                                        <th style="font-size:90%">숨김처리취소</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(list, index) in searchProducts" :key="index">
                                        <td style="min-width:300px;">
                                            <div class="d-flex align-items-center" v-b-modal="'modalpurchase' + index">
                                                <img :src="list.optionImageUrl" class="img-fluid rounded avatar-80 mr-3"
                                                    alt="image">
                                                <div>
                                                    {{ list.productName }}
                                                    <p class="mb-0"><small>노출Id : {{ list.productId }}</small></p>
                                                    <p class="mb-0"><small>옵션Id : {{ list.vendorItemId }}</small></p>
                                                    <p class="mb-0"><small>승인상태 : {{ list.statusName }}</small></p>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <b-button @click="addSearchProduct(list, index)" variant="outline-primary"
                                                class="text-center">숨김처리취소</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </b-modal>







            <!-- 매입정보 관리 모달 (growthdb.vue 스타일 통합) -->
            <b-modal size="xl" id="excelupload" scrollable title="매입정보 관리" hide-footer>
                <!-- 탭 네비게이션 -->
                <b-tabs v-model="activeTab" content-class="mt-3">
                    <!-- 일괄 업로드 탭 -->
                    <b-tab title="일괄 업로드" active>
                        <div class="row">
                            <div class="col-md-12">
                                <p><strong>[업로드 방법]</strong></p>
                                <p>1. 엑셀업로드 포맷 다운로드 → 2. 엑셀 파일에서 매입정보 업데이트 → 3. 업데이트된 엑셀 파일 업로드</p>
                                <p><small class="text-muted">* 동일 날짜 데이터가 있으면 자동으로 새 데이터로 교체됩니다.</small></p>
                            </div>
                        </div>

                        <!-- SKU ID 매칭 방식 -->
                        <div class="card mb-3">
                            <div class="card-header bg-primary text-white">
                                <h6 class="mb-0"><i class="fa fa-barcode mr-2"></i>SKU ID로 매칭</h6>
                            </div>
                            <div class="card-body">
                                <div class="row align-items-end">
                                    <div class="col-md-4">
                                        <label class="form-label">엑셀 포맷 다운로드</label>
                                        <div>
                                            <button type="button" @click="formatDownload('SKUID')"
                                                class="btn btn-outline-primary btn-block">
                                                <i class="fa fa-download mr-1"></i>SKU ID 포맷 다운로드
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">엑셀 파일 업로드</label>
                                        <div class="custom-file">
                                            <input ref="skuidUpload" type="file" @change="uploadfile($event, 'SKUID')"
                                                class="custom-file-input" id="skuidFile" accept=".xlsx,.xls">
                                            <label class="custom-file-label" for="skuidFile">{{ uploadstatus }}</label>
                                        </div>
                                    </div>
                                    <div class="col-md-2" v-if="showuploadspinner && currentUploadType === 'SKUID'">
                                        <img style="width:30px;" :src="require('../../../assets/images/small/loading.gif')">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 바코드 매칭 방식 -->
                        <div class="card">
                            <div class="card-header bg-success text-white">
                                <h6 class="mb-0"><i class="fa fa-qrcode mr-2"></i>바코드(barcode)로 매칭</h6>
                            </div>
                            <div class="card-body">
                                <div class="row align-items-end">
                                    <div class="col-md-4">
                                        <label class="form-label">엑셀 포맷 다운로드</label>
                                        <div>
                                            <button type="button" @click="formatDownload('barcode')"
                                                class="btn btn-outline-success btn-block">
                                                <i class="fa fa-download mr-1"></i>바코드 포맷 다운로드
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label">엑셀 파일 업로드</label>
                                        <div class="custom-file">
                                            <input ref="barcodeUpload" type="file" @change="uploadfile($event, 'barcode')"
                                                class="custom-file-input" id="barcodeFile" accept=".xlsx,.xls">
                                            <label class="custom-file-label" for="barcodeFile">{{ uploadstatus2 }}</label>
                                        </div>
                                    </div>
                                    <div class="col-md-2" v-if="showuploadspinner && currentUploadType === 'barcode'">
                                        <img style="width:30px;" :src="require('../../../assets/images/small/loading.gif')">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-tab>

                    <!-- 매입정보 관리 탭 -->
                    <b-tab title="매입정보 관리">
                        <!-- 액션 버튼 바 -->
                        <div class="row mb-3">
                            <div class="col-12">
                                <button type="button" class="btn btn-success mr-2" @click="addNewImportInfo">
                                    <i class="fa fa-plus"></i> 새 항목 추가
                                </button>
                                <button type="button" class="btn btn-warning mr-2" @click="exportImportInfoToExcel">
                                    <i class="fa fa-download"></i> 엑셀 다운로드
                                </button>
                                <button type="button" class="btn btn-danger mr-2" @click="deleteSelectedImportInfo"
                                    :disabled="selectedImportInfoItems.length === 0">
                                    <i class="fa fa-trash"></i> 선택 삭제
                                </button>
                                <button type="button" class="btn btn-outline-danger" @click="deleteAllImportInfo">
                                    <i class="fa fa-trash-alt"></i> 전체 삭제
                                </button>
                            </div>
                        </div>

                        <!-- 매입정보 테이블 -->
                        <CDataTable
                            storage-key="rocketProductManagement.2"
                            :headers="importInfoHeaders"
                            :items="filteredImportInfos"
                            v-model="selectedImportInfoItems"
                            :show-select="true"
                            :items-per-page="20"
                            :item-key="'id'"
                            class="table-responsive">

                            <template v-slot:노출ID="{ item }">
                                <span class="text-primary">{{ item.productId }}</span>
                            </template>

                            <template v-slot:SKUID="{ item }">
                                <span class="text-info">{{ item.SKUID }}</span>
                            </template>

                            <template v-slot:상품명="{ item }">
                                <div class="text-truncate" style="max-width: 200px;" :title="item.productName">
                                    {{ item.productName }}
                                </div>
                            </template>

                            <template v-slot:매입일자="{ item }">
                                <div v-if="item.editing">
                                    <input type="date" class="form-control form-control-sm"
                                        v-model="item.date"
                                        @keyup.enter="saveImportInfoEdit(item)"
                                        @blur="saveImportInfoEdit(item)">
                                </div>
                                <div v-else>{{ item.date }}</div>
                            </template>

                            <template v-slot:매입가="{ item }">
                                <div v-if="item.editing">
                                    <input type="number" class="form-control form-control-sm"
                                        v-model="item.매입가"
                                        @keyup.enter="saveImportInfoEdit(item)"
                                        @blur="saveImportInfoEdit(item)">
                                </div>
                                <div v-else>{{ item.매입가 | currency }}</div>
                            </template>

                            <template v-slot:액션="{ item }">
                                <div>
                                    <button v-if="!item.editing" type="button" class="btn btn-sm btn-outline-primary mr-1"
                                        @click="editImportInfo(item)">
                                        <i class="fa fa-edit"></i>
                                    </button>
                                    <button v-if="item.editing" type="button" class="btn btn-sm btn-success mr-1"
                                        @click="saveImportInfoEdit(item)">
                                        <i class="fa fa-check"></i>
                                    </button>
                                    <button v-if="item.editing" type="button" class="btn btn-sm btn-secondary mr-1"
                                        @click="cancelImportInfoEdit(item)">
                                        <i class="fa fa-times"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-outline-danger"
                                        @click="deleteImportInfo(item)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </template>
                        </CDataTable>

                        <!-- 페이지네이션 정보 -->
                        <div class="row mt-3">
                            <div class="col-12">
                                <small class="text-muted">
                                    총 {{ totalImportInfoRows }}개의 매입정보
                                </small>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>

                <!-- 모달 하단 버튼 -->
                <template #modal-footer>
                    <button type="button" class="btn btn-secondary" @click="closeImportInfoModal">닫기</button>
                </template>
            </b-modal>




                        </div>
                    </b-tab>

                    <b-tab title="상품 등록 상태" lazy>
                        <RegistrationInspection :suppliercode="suppliercode" />
                    </b-tab>
                </b-tabs>
            </div>

        </div>

            <!-- 허용스토어 설정 모달 -->
            <b-modal id="rocketVendorNameModal" size="lg" title="허용 스토어 설정" ok-title="저장" cancel-title="취소"
                @ok="saveRocketAllowedVendorNames" @cancel="cancelVendorNameModal">
                <div class="row">
                    <div class="col-md-12">
                        <p><b>타사매칭 여부 확인을 위한 허용 스토어를 설정해주세요.</b></p>
                        <p>설정된 스토어 외의 다른 판매자가 있는 상품은 '타사매칭' 상품으로 분류됩니다.</p>
                        <div class="form-group">
                            <label>허용 스토어 목록 (쉼표로 구분, 예: 마이브랜드, 곰곰, 탐사)</label>
                            <textarea v-model="allowedVendorNamesText" class="form-control" rows="4"
                                placeholder="예: 마이브랜드, 곰곰, 탐사"></textarea>
                        </div>
                        <div class="form-group d-flex align-items-center" v-if="currentAllowedVendorNames.length > 0">
                            <label>현재 설정된 허용 스토어</label>
                            <div class="d-flex flex-wrap ml-3">
                                <span v-for="(name, index) in currentAllowedVendorNames" :key="index"
                                    class="badge badge-primary mr-2 mb-2">{{ name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>

        <!-- Page end  -->
    </div>
</template>

<style scoped>
/* growthdb.vue에서 가져온 구매요청사항 폼 스타일 */
.reqpo-purchase-request-form {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.reqpo-form-section {
    margin-bottom: 1.5rem;
    padding: 1rem;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background-color: #f8f9fa;
}

.reqpo-section-title {
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.75rem;
    font-size: 0.95rem;
}

.reqpo-input-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.reqpo-stock-info {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.85rem;
    color: #6c757d;
}

.reqpo-info-label {
    font-weight: 500;
}

.reqpo-info-value {
    font-weight: 600;
    color: #495057;
}

.reqpo-separator {
    margin: 0 0.25rem;
    color: #adb5bd;
}

.bundle-options {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.bundle-count {
    margin-left: 1rem;
}

.destination-options .btn-group {
    border-radius: 6px;
    overflow: hidden;
}

.export-options {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.customs-options {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.reqpo-custom-radio-card {
    padding: 0.75rem;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: white;
}

.reqpo-custom-radio-card:hover {
    border-color: #007bff;
    background-color: #f8f9ff;
}

.reqpo-custom-radio-card.active {
    border-color: #007bff;
    background-color: #e7f3ff;
}

.reqpo-card-title {
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.25rem;
}

.reqpo-card-desc {
    font-size: 0.8rem;
    color: #6c757d;
    line-height: 1.3;
}

.inspection-options {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.packaging-options {
    padding: 0.75rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    background-color: white;
}

.reqpo-option-title {
    font-weight: 600;
    color: #495057;
    font-size: 0.9rem;
}

.reqpo-text-muted {
    color: #6c757d !important;
    font-size: 0.8rem;
}

/* 매입정보 모달 스타일 개선 */
.table-hover tbody tr:hover {
    background-color: rgba(0, 123, 255, 0.075);
}

.thead-light th {
    background-color: #f8f9fa;
    border-color: #dee2e6;
    font-weight: 600;
    font-size: 0.9rem;
}

.btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
}

.form-control-sm {
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
}
</style>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';
import VueBarcode from 'vue-barcode';
import CDataTable from "@/components/common/CDataTable";
import RegistrationInspection from "@/components/AIRocket/RegistrationInspection";
export default {
    name: 'RocketProductManagement',
    components: {
        'barcode': VueBarcode,
        CDataTable,
        RegistrationInspection
    },
    data() {
        return {
            headers: [
                { text: '이미지', value: '이미지', align: 'center', width: 100, isSlot: true },
                { text: '상품명', value: '상품명', align: 'center', width: 300, isSlot: true },
                { text: 'SKU ID', value: 'SKUID', align: 'center', width: 100, isSlot: true },
                { text: '바코드', value: '바코드', align: 'center', width: 100, isSlot: true },
                { text: '노출ID', value: '노출ID', align: 'center', width: 100, isSlot: true },
                { text: '옵션ID', value: '옵션ID', align: 'center', width: 100, isSlot: true },
                { text: '판매링크', value: '판매링크', align: 'center', width: 100, isSlot: true },
                { text: '발주가능상태', value: '발주가능상태', align: 'center', width: 100, isSlot: true },
                { text: '쿠팡재고', value: '재고', align: 'center', width: 80, isSlot: true },
                { text: '판매가', value: '판매가', align: 'center', width: 100, isSlot: true },
                { text: '공급가', value: '공급가', align: 'center', width: 100, isSlot: true },
                { text: '리뷰평점', value: '리뷰평점', align: 'center', width: 80, isSlot: true },
                { text: '리뷰수', value: '리뷰수', align: 'center', width: 80, isSlot: true },
                { text: '구매정보', value: '구매정보', align: 'center', width: 100, isSlot: true },
                { text: '매입관리', value: '매입가', align: 'center', width: 100, isSlot: true },
                { text: '마진', value: '마진', align: 'center', width: 100, isSlot: true },
                { text: '마진율', value: '마진율', align: 'center', width: 80, isSlot: true },
                { text: 'ROI', value: 'ROI', align: 'center', width: 80, isSlot: true },
                { text: '최소ROAS', value: '최소ROAS', align: 'center', width: 80, isSlot: true },
                { text: '쿠팡마진', value: '쿠팡마진', align: 'center', width: 100, isSlot: true },
                { text: '쿠팡마진율', value: '쿠팡마진율', align: 'center', width: 80, isSlot: true },
                { text: '바코드출력', value: '바코드출력', align: 'center', width: 100, isSlot: true }
            ],
            tableSelectedItem: [],
            showReturnProducts: false,
            showBundleProducts: false,

            showspinner2: false,
            showHideProducts: false,
            showPurchase: true,

            packageMethod: 'auto',
            editmode: false,
            searchProducts: [],
            addProducts: [],
            노출상품번호: '',
            등록상품번호: '',
            옵션번호: '',
            purchaseItem: {},
            isCollapseOpen: false,
            allchecked: false,

            PurchaseMappingSearch: false,
            searchPurchaseMapping: '',
            loadingtext: '',

            title: "로켓배송 상품관리 (신규)",
            desc1: "로켓배송 상품DB를 최신 포맷으로 관리합니다.",
            desc2: "상품의 구매정보 및 매입가 정보를 입력하여 효율적인 상품 관리가 가능합니다.",

            showlist: false,
            showspinner: false,
            showspinner1: false,
            barcode: '',
            SKUID: '',
            상품명: '',
            구매링크: '',
            제품분류: '',
            ProductList: {
                등록이미지: '',
                구매링크: '',
                옵션1_중국어: '',
                옵션2_중국어: '',
                판매구성수량: '',
                구매가능상태: '',
            },
            editQty: false,

            // 바코드 출력 관련 데이터
            printskuenable: true,
            printkcenable: false,
            printfoodenable: false,
            원산지: 'Made in China',
            바코드출력: '',
            SKU출력: '',
            출력수량: 1,
            바코드간격: 0,
            enabledetail: true,
            출력SKUID: '',
            출력바코드: '',
            출력상품명: '',
            한글표시사항: {
                '수입원/판매원': '',
                제조원: '',
                제조국: '',
                내용량: '',
                '원료명및성분명(재질)': '',
                상품유형: '',
                사용시주의사항: '',
                사용기준: '',
                custom: '',
                kc인증: false,
                식품용: false,
            },
            bcvalue: '',
            bctag: 'svg',
            bcoptions: {
                lineColor: '#ff7069',
                fontSize: 50,
                font: 'Courier',
                width: 3,
                height: 60,
                marginBottom: 60,
                format: 'MSI',
                background: '#ccffff'
            },

            // 검색 관련 데이터
            searchBarcode: '',
            searchSKUID: '',
            searchProductName: '',

            // 본문 탭(등록 상품 / 상품 등록 상태). 아래 activeTab 은 일괄업로드 모달 안의 탭이라 별개다.
            regPageTab: 0,

            // 매입정보 관리 관련 데이터 (growthdb.vue 스타일)
            activeTab: 0,
            selectedFile: null,
            selectedFile2: null,
            uploadstatus: '업로드',
            uploadstatus2: '업로드',
            showuploadspinner: false,
            currentUploadType: null,

            // 매입정보 테이블 관련
            importInfoHeaders: [
                { text: '노출ID', value: '노출ID', align: 'center', width: 100, isSlot: true },
                { text: 'SKU ID', value: 'SKUID', align: 'center', width: 120, isSlot: true },
                { text: '상품명', value: '상품명', align: 'center', width: 300, isSlot: true },
                { text: '매입일자', value: '매입일자', align: 'center', width: 120, isSlot: true },
                { text: '매입가', value: '매입가', align: 'center', width: 100, isSlot: true },
                { text: '액션', value: '액션', align: 'center', width: 150, isSlot: true }
            ],
            flatImportInfos: [],
            filteredImportInfos: [],
            selectedImportInfoItems: [],
            importInfoFilter: {
                startDate: '',
                endDate: '',
                searchText: ''
            },

            // link:{ name: 'product.addproduct'},
            // linktext:"Add Product",
            //    selected: '',
            //    menuint: ["옵션1_중국어","옵션2_중국어","제품분류","판매구성수량","구매가능상태"],
            //    menuDefault: ["옵션1_중국어","옵션2_중국어","제품분류","판매구성수량","구매가능상태"],
            //    menuCost: ["발주가능상태","매입단가","공급가액","부가세액"],
            //    // menuSales: ["바코드","구매링크","판매가격","판매링크","판매재고","판매상품명"],
            productLists: [], //this.$store.state.productdb,
            productListsinit: [],

            // 필터링 카운트 변수들
            total: 0,
            발주불가: 0,
            바코드없음: 0,
            제품분류없음: 0,
            구매정보없음: 0,
            매입정보없음: 0,
            발주가능상태목록: [],


            아이템루저: 0,
            뱃지없음: 0,
            구매정보있음: 0,
            번들정보있음: 0,
            노출ID변경: 0,
            공급가변경: 0,
            타사매칭: 0,
            showImport: true,
            currentIndex: '',
            allowedVendorNamesText: '',
            currentAllowedVendorNames: []
        }
    },
    computed: {
        // 상품 등록 상태 탭이 쿠팡에 물어볼 때 쓴다. 화면이 값을 넣지 않고 로그인한 계정 것을 쓴다.
        suppliercode() {
            return (this.$store.state.user && this.$store.state.user.suppliercode) || '';
        },

        // 판매가 기준일은 회사 단위로 하나다(판매현황 문서 1건에서 전부 나온다).
        판매현황기준일() {
            const hit = (this.productListsinit || []).find(e => e.판매가기준일);
            return hit ? hit.판매가기준일 : null;
        },

        판매현황경과일() {
            if (!this.판매현황기준일) return null;
            const 기준 = new Date(this.판매현황기준일);
            if (isNaN(기준.getTime())) return null;
            return Math.floor((new Date() - 기준) / 86400000);
        },

        // 바코드 출력 관련 computed (listproduct.vue와 동일)
        printsku() {
            if (this.printskuenable) {
                return 'font-size:90%;color:black;'
            } else {
                return 'display:none;font-size:90%;color:black;'
            }
        },
        enablekr() {
            if (this.enabledetail) {
                return 'font-size:80%;color:black;line-height:110%;display:block;margin-bottom:0px;'
            } else {
                return 'font-size:80%;color:black;line-height:110%;display:none'
            }
        },
        disablekr() {
            if (this.enabledetail) {
                return 'font-size:80%;color:black;line-height:110%;display:none'
            } else {
                return 'font-size:80%;color:black;line-height:110%;display:block'
            }
        },
        printkc() {
            if (this.printkcenable) {
                return 'font-size:90%;color:black;margin-left:20px;margin-top:10px'
            } else {
                return 'display:none;font-size:90%;color:black;'
            }
        },
        productIdChangedTooltip() {
            if (!this.productLists || this.productLists.length === 0) {
                return '7일 이내 노출ID가 변경된 상품이 없습니다.';
            }
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
            const changedProducts = this.productLists.filter(e => {
                if (!e.productIdHistory || e.productIdHistory.length === 0) return false;
                return e.productIdHistory.some(history => new Date(history.date) >= sevenDaysAgo);
            });
            if (changedProducts.length === 0) return '7일 이내 노출ID가 변경된 상품이 없습니다.';
            let tooltip = '<div style="text-align: left; max-width: 350px;"><strong>노출ID 변경 상품:</strong><br>';
            changedProducts.slice(0, 5).forEach(product => {
                const recentChanges = product.productIdHistory
                    .filter(history => new Date(history.date) >= sevenDaysAgo)
                    .sort((a, b) => new Date(b.date) - new Date(a.date));
                if (recentChanges.length > 0) {
                    const latestChange = recentChanges[0];
                    const changeDate = new Date(latestChange.date).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' });
                    tooltip += `<div style="margin: 3px 0; font-size: 12px;">• ${product.상품명 || '상품명 없음'}<br><span style="color: #6c757d; margin-left: 8px;">${latestChange.productId} → ${product.노출ID || product.productId} (${changeDate})</span></div>`;
                }
            });
            if (changedProducts.length > 5) tooltip += `<div style="margin-top: 5px; font-size: 11px; color: #6c757d;">외 ${changedProducts.length - 5}개...</div>`;
            tooltip += '</div>';
            return tooltip;
        },
        priceChangedTooltip() {
            if (!this.productLists || this.productLists.length === 0) {
                return '7일 이내 공급가가 변경된 상품이 없습니다.';
            }
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
            const changedProducts = this.productLists.filter(e => {
                if (!e.priceHistory || e.priceHistory.length === 0) return false;
                return e.priceHistory.some(history => new Date(history.date) >= sevenDaysAgo);
            });
            if (changedProducts.length === 0) return '7일 이내 공급가가 변경된 상품이 없습니다.';
            let tooltip = '<div style="text-align: left; max-width: 350px;"><strong>공급가 변경 상품:</strong><br>';
            changedProducts.slice(0, 5).forEach(product => {
                const recentChanges = product.priceHistory
                    .filter(history => new Date(history.date) >= sevenDaysAgo)
                    .sort((a, b) => new Date(b.date) - new Date(a.date));
                if (recentChanges.length > 0) {
                    const latestChange = recentChanges[0];
                    const changeDate = new Date(latestChange.date).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' });
                    tooltip += `<div style="margin: 3px 0; font-size: 12px;">• ${product.상품명 || '상품명 없음'}<br><span style="color: #6c757d; margin-left: 8px;">${(latestChange.price || 0).toLocaleString()}원 → ${(product.공급가 || 0).toLocaleString()}원 (${changeDate})</span></div>`;
                }
            });
            if (changedProducts.length > 5) tooltip += `<div style="margin-top: 5px; font-size: 11px; color: #6c757d;">외 ${changedProducts.length - 5}개...</div>`;
            tooltip += '</div>';
            return tooltip;
        },
        otherSellersTooltip() {
            if (!this.productLists || this.productLists.length === 0) return '타사매칭 상품이 없습니다.';
            const matchingProducts = this.productLists.filter(e => e.otherSellers && e.otherSellers.hasOtherSellers);
            if (matchingProducts.length === 0) return '허용되지 않은 타사가 매칭된 상품이 없습니다.';
            let tooltip = '<div style="text-align: left; max-width: 350px;"><strong>타사매칭 상품:</strong><br>';
            matchingProducts.slice(0, 5).forEach(product => {
                if (product.otherSellers && product.otherSellers.otherVendorNames && product.otherSellers.otherVendorNames.length > 0) {
                    tooltip += `<div style="margin: 3px 0; font-size: 12px;">• ${product.상품명 || '상품명 없음'}<br><span style="color: #dc3545; margin-left: 8px;">${product.otherSellers.otherVendorNames.join(', ')}</span></div>`;
                }
            });
            if (matchingProducts.length > 5) tooltip += `<div style="margin-top: 5px; font-size: 11px; color: #6c757d;">외 ${matchingProducts.length - 5}개...</div>`;
            tooltip += '</div>';
            return tooltip;
        },
        // 매입정보 관련 computed 속성들 (growthdb.vue 스타일)
        totalImportInfoRows() {
            return this.filteredImportInfos.length;
        }
    },
    filters: {
        currency(value) {
            if (!value) return '0';
            return parseInt(value).toLocaleString();
        }
    },
    beforeDestroy() {
        window.removeEventListener('message', this.messageEventHandler);
        if (this.messageHandler) {
            window.removeEventListener('message', this.messageHandler)
        }
    },
    mounted() {
        this.loadProductData()
        // 수집 완료/실패 메시지 수신
        this.messageHandler = (event) => {
            if (event.data?.type === 'manualCollectComplete' && event.data.itemKey === 'rocketDeliverySKU') {
                this.showspinner1 = false
                this.loadingtext = ''
                if (event.data.success === false) {
                    alert(event.data.error || 'SKU 수집에 실패했습니다.')
                } else {
                    this.loadProductData()
                }
            }
        }
        window.addEventListener('message', this.messageHandler)
    },
    methods: {
        // 판매링크에서 노출ID(productId) 추출
        extractProductId(link) {
            if (!link) return '';
            const match = link.match(/products\/(\d+)/);
            return match ? match[1] : '';
        },

        // 판매링크에서 옵션ID(vendorItemId) 추출
        extractVendorItemId(link) {
            if (!link) return '';
            const match = link.match(/vendorItemId=(\d+)/);
            return match ? match[1] : '';
        },

        // 최신 매입가 계산 (무한 루프 방지용)
        calculateLatestImportPrice(importInfoArray) {
            if (!importInfoArray || importInfoArray.length === 0) return 0;
            const sortedImports = [...importInfoArray].sort((a, b) => new Date(b.date) - new Date(a.date));
            return sortedImports[0].매입가 || 0;
        },

        // 상품 데이터에 계산된 값들을 추가하는 메서드
        addCalculatedFields(items) {
            return items.map(item => {
                // 쿠팡마진 계산 (판매가 - 공급가)
                const 쿠팡마진 = (item.판매가 && item.공급가) ? item.판매가 - item.공급가 : 0;
                const 쿠팡마진율 = (item.판매가 && item.공급가 && item.판매가 > 0) ?
                    ((item.판매가 - item.공급가) / item.판매가 * 100) : 0;

                // 나의 마진 계산 (공급가 - 매입가) * 10/11
                const 마진 = (item.공급가 && item.latestImportPrice > 0) ?
                    (item.공급가 - item.latestImportPrice) * 10 / 11 : 0;
                const 마진율 = (item.공급가 && item.latestImportPrice > 0 && item.공급가 > 0) ?
                    (((item.공급가 - item.latestImportPrice) * 10 / 11) / item.공급가 * 100) : 0;

                // ROI 계산 (마진/매입가 * 100)
                const ROI = (마진 > 0 && item.latestImportPrice > 0) ?
                    (마진 / (item.latestImportPrice * 10 / 11) * 100) : 0;

                // 최소ROAS 계산 (판매가/마진)
                const 최소ROAS = (마진 > 0 && item.판매가 > 0) ?
                    (item.판매가 / 마진) : 0;

                return {
                    ...item,
                    쿠팡마진: 쿠팡마진,
                    쿠팡마진율: 쿠팡마진율,
                    마진: 마진,
                    마진율: 마진율,
                    ROI: ROI,
                    최소ROAS: 최소ROAS
                };
            });
        },

        // RocketPurchaseDB에 매입정보 저장 (로켓배송 전용)
        async saveImportInfo(data, showAlert) {
            try {
                // RocketPurchaseDB에 저장할 데이터 구성 (SKU ID로 매칭)
                const purchaseData = {
                    vendorItemId: data.vendorItemId || data.옵션ID,
                    SKUID: data.SKUID || data.skuId,
                    구매정보: data.구매정보 || [],
                    매입정보: data.매입정보 || []
                };

                const res = await axios.post('/api/rocketpurchasedb/save', purchaseData);

                if (res.data.res !== 'success') {
                    if (showAlert) alert('저장실패(901) : ' + res.data.alert);
                    return false;
                } else {
                    if (showAlert) alert('저장완료');
                    return true;
                }
            } catch (e) {
                if (showAlert) alert('저장실패(905) : ' + e);
                return false;
            }
        },

        // 개별 상품 바코드 출력 (listproduct.vue 방식)
        printSingleBarcode(item) {
            // 바코드 출력을 위한 데이터 설정
            this.출력SKUID = item.SKUID || item['SKU ID'];
            this.출력바코드 = item.바코드;
            this.출력상품명 = item.상품명;

            // 한글표시사항 설정 (item에서 가져오거나 기본값)
            this.한글표시사항 = {
                '수입원/판매원': item['수입원/판매원'] || item.한글표시사항?.['수입원/판매원'] || '쿠플러스',
                제조원: item.제조원 || item.한글표시사항?.제조원 || '',
                제조국: item.제조국 || item.한글표시사항?.제조국 || '',
                내용량: item.내용량 || item.한글표시사항?.내용량 || '',
                '원료명및성분명(재질)': item['원료명및성분명(재질)'] || item.한글표시사항?.['원료명및성분명(재질)'] || '',
                상품유형: item.상품유형 || item.한글표시사항?.상품유형 || '',
                사용시주의사항: item.사용시주의사항 || item.한글표시사항?.사용시주의사항 || '',
                사용기준: item.사용기준 || item.한글표시사항?.사용기준 || ''
            };
            this.printkcenable = item.한글표시사항?.kc인증 || false;
            this.printfoodenable = item.한글표시사항?.식품용 || false;

            // 출력 수량 기본값 설정
            this.출력수량 = 1;

            // Vue 컴포넌트를 사용한 바코드 출력 (listproduct.vue와 동일)
            setTimeout(() => {
                this.print('printSingleBarcode');
            }, 10);
        },
        // 구매정보 모달 한글표시사항에서 직접 바코드 출력
        printBarcodeFromPurchase(list, item) {
            this.출력SKUID = item?.SKUID || '';
            this.출력바코드 = list.바코드;
            this.출력상품명 = list.상품명;
            this.한글표시사항 = {
                '수입원/판매원': list.한글표시사항?.['수입원/판매원'] || '',
                제조원: list.한글표시사항?.제조원 || '',
                제조국: list.한글표시사항?.제조국 || '',
                내용량: list.한글표시사항?.내용량 || '',
                '원료명및성분명(재질)': list.한글표시사항?.['원료명및성분명(재질)'] || '',
                상품유형: list.한글표시사항?.상품유형 || '',
                사용시주의사항: list.한글표시사항?.사용시주의사항 || '',
                사용기준: list.한글표시사항?.사용기준 || ''
            };
            this.printkcenable = list.한글표시사항?.kc인증 || false;
            this.printfoodenable = list.한글표시사항?.식품용 || false;
            this.출력수량 = 1;
            setTimeout(() => {
                this.print('printSingleBarcode');
            }, 10);
        },

        // 바코드 간격 스타일 (listproduct.vue와 동일)
        barcodegap(index, total) {
            if (index < total) {
                return 'border:0px solid silver;width:300px;text-align: center;margin-bottom:' + this.바코드간격 + 'px';
            } else {
                return 'border:0px solid silver;width:300px;text-align: center;';
            }
        },

        // 인쇄 함수 (listproduct.vue와 동일)
        async print(id) {
            const options = {
                name: '_blank',
                autoClose: true,
            };
            await this.$htmlToPaper(id, options);
        },

        // 마진율에 따른 색상 결정
        getMarginVariant(item) {
            if (!item.판매가 || !item.latestImportPrice || item.latestImportPrice <= 0) return 'secondary';
            const marginRate = ((item.판매가 - item.latestImportPrice) / item.판매가) * 100;
            if (marginRate >= 30) return 'success';
            if (marginRate >= 20) return 'warning';
            if (marginRate >= 10) return 'info';
            return 'danger';
        },

        // ROI에 따른 색상 결정
        getROIVariant(item) {
            if (!item.ROI || item.ROI <= 0) return 'secondary';
            if (item.ROI >= 100) return 'success';  // 100% 이상
            if (item.ROI >= 50) return 'warning';   // 50% 이상
            if (item.ROI >= 20) return 'info';      // 20% 이상
            return 'danger';                        // 20% 미만
        },

        // 쿠팡마진율에 따른 색상 결정
        getCoupangMarginVariant(item) {
            if (!item.판매가 || !item.공급가) return 'secondary';
            const marginRate = ((item.판매가 - item.공급가) / item.판매가) * 100;
            if (marginRate >= 30) return 'success';
            if (marginRate >= 20) return 'warning';
            if (marginRate >= 10) return 'info';
            return 'danger';
        },

        // growthdb.vue에서 가져온 메서드들
        option1matching(a, list) {
            if (a.imageUrl) {
                list.등록이미지 = a.imageUrl;
                list.옵션이미지 = a.imageUrl;
            }
            list.옵션1_중국어 = a.name;

            // 재고 확인 로직
            if (list.옵션2_중국어 == '' || !list.옵션2_중국어) {
                list.item.productSkuInfos.forEach(e => {
                    if (e.skuAttributes[0].value === list.옵션1_중국어) {
                        list.구매재고 = e.amountOnSale
                    }
                })
                if (list.구매재고 == 0) {
                    alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                } else {
                    alert('구매 가능한 재고수량 : ' + list.구매재고)
                    list.매칭상태 = '매칭완료';
                }
            } else {
                if (list.옵션2_중국어 !== undefined) {
                    list.item.productSkuInfos.forEach(e => {
                        if (e.skuAttributes[0].value === list.옵션1_중국어 &&
                            e.skuAttributes[1].value === list.옵션2_중국어) {
                            list.구매재고 = e.amountOnSale
                        }
                    })
                    if (list.구매재고 == 0) {
                        alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                    } else {
                        alert('구매 가능한 재고수량 : ' + list.구매재고)
                        list.매칭상태 = '매칭완료';
                    }
                } else {
                    // 옵션2 목록 생성
                    list.상품매칭.옵션2_중국어 = []
                    list.item.productSkuInfos.forEach(e => {
                        if (e.skuAttributes[0].value === list.옵션1_중국어) {
                            list.상품매칭.옵션2_중국어.push({
                                name: e.skuAttributes[1].value,
                                imageUrl: e.skuAttributes[1].skuImageUrl ? e.skuAttributes[1].skuImageUrl : '',
                            })
                        }
                    })
                }
            }
        },

        option2matching(a, list) {
            if (a.imageUrl) {
                list.등록이미지 = a.imageUrl;
            }
            list.옵션2_중국어 = a.name;

            if (list.옵션1_중국어 !== undefined) {
                list.item.productSkuInfos.forEach(e => {
                    if (e.skuAttributes[0].value === list.옵션1_중국어 &&
                        e.skuAttributes[1].value === list.옵션2_중국어) {
                        list.구매재고 = e.amountOnSale
                    }
                })
                if (list.구매재고 == 0) {
                    alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                } else {
                    alert('구매 가능한 재고수량 : ' + list.구매재고)
                    list.매칭상태 = '매칭완료';
                }
            }
        },

        getMinOrderQuantity(list) {
            if (!list.item) return 2;
            return list.item?.minOrderQuantity || 2;
        },

        getAvailableStock(list) {
            if (!list.item || !list.item.productSaleInfo) return 0;

            let stock = 0;
            if (!list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSaleInfo.amountOnSale);
            } else if (list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어
                )?.amountOnSale || 0);
            } else {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어 &&
                    f.skuAttributes[1].value == list.옵션2_중국어
                )?.amountOnSale || 0);
            }
            return stock;
        },

        validateQuantity(list) {
            const minQuantity = this.getMinOrderQuantity(list);
            const maxQuantity = this.getAvailableStock(list);
            const currentQuantity = parseInt(list.구매요청수량);

            if (currentQuantity < minQuantity) {
                alert(`최소 주문수량(${minQuantity}개)보다 적습니다.`);
                list.구매요청수량 = minQuantity;
            } else if (currentQuantity > maxQuantity) {
                alert(`구매 가능한 최대 수량(${maxQuantity}개)을 초과하였습니다.`);
                list.구매요청수량 = maxQuantity;
            }
        },

        editQtyEnter() {
            this.editQty = false;
        },

        reqclass(a) {
            if (a == '등록완료') {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },

        async savereq($event, list, index) {
            $event.preventDefault();
            var foo = this.confirmlist(list)
            if (!foo) {
                return
            }
            list.요청사항 = '등록완료';
            console.log(list)

            this.$nextTick(() => {
                this.$bvModal.hide('modalreq' + index);
                console.log('modalreq' + index)
            })
        },



        changeBarcode(item) {
            if (!item.요청내역.barcode) {
                alert('바코드라벨 미부착 시 반드시 원산지가 표시되어 있어야 합니다.')
                item.요청내역.sticker = true;
            } else {
                item.요청내역.sticker = false;
            }
        },











        matchclass(a) {
            if (a == '매칭완료') {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },

        // growthdb.vue 스타일 매입정보 관리 메서드들
        async loadProductData() {
            this.showspinner = true
            try {
                // 서버에서 통합된 데이터 가져오기
                const response = await axios.post('/api/product/getRocketProductData', {})

                if (response.data && response.data.success) {
                    this.processProductData(response.data.data)
                    console.log('통합 상품 데이터 로드 성공:', response.data.data.length)
                } else {
                    throw new Error(response.data?.message || '데이터 로드 실패')
                }
            } catch (error) {
                console.error('상품 데이터 로드 실패:', error)
                this.productLists = []
            } finally {
                this.showspinner = false
                this.showlist = true
            }
        },



        processProductData(data) {
            // 서버에서 이미 통합된 데이터를 처리
            const processedData = data.map(item => {
                const skuId = item['SKU ID'] || item.SKUID

                // 판매링크에서 노출ID, 옵션ID 추출
                const 판매링크 = item.판매링크 || ''
                const 노출ID = this.extractProductId(판매링크)
                const 옵션ID = this.extractVendorItemId(판매링크)

                // 최신 매입가 미리 계산 (무한 루프 방지)
                const latestImportPrice = this.calculateLatestImportPrice(item.매입정보 || []);

                return {
                    _id: item._id,
                    SKUID: skuId,
                    상품명: item.판매상품명 || item.상품명,
                    바코드: item.바코드,
                    노출ID: 노출ID,
                    옵션ID: 옵션ID,
                    vendorItemId: 옵션ID,
                    productId: 노출ID,
                    판매링크: 판매링크,
                    발주가능상태: item.발주가능상태,
                    재고: item.재고,
                    판매가: item.판매가,
                    // 판매가가 언제 수집된 값인지. 없으면 화면이 낡은 값을 최신처럼 보여준다
                    판매가기준일: item.판매가기준일 || null,
                    공급가: item.공급가 || item.skudetail?.detail?.body?.price || 0,  // 쿠팡에 공급하는 가격
                    리뷰평점: item.리뷰평점,
                    리뷰수: item.리뷰수,
                    썸네일: item.썸네일,
                    구매링크: item.구매링크,
                    옵션1_중국어: item.옵션1_중국어,
                    옵션2_중국어: item.옵션2_중국어,
                    판매구성수량: item.판매구성수량 || 1,
                    매입가: item.매입가,  // 내가 구매해서 가져오는 가격
                    매입정보: item.매입정보 || [],  // growthdb 스타일 매입정보 배열
                    latestImportPrice: latestImportPrice,  // 미리 계산된 최신 매입가
                    매입단가: item.매입단가,
                    공급가액: item.공급가액,
                    부가세액: item.부가세액,
                // growthdb와 동일한 구매정보 구조 - 기존 데이터 보존
                구매정보: item.구매정보 || [],
                구매정보여부: false,
                // 필터용 데이터
                winner: item.winner || '',
                productIdHistory: item.productIdHistory || [],
                priceHistory: item.priceHistory || [],
                otherSellers: item.otherSellers || null
            }
            });

            // growthdb searchResult 방식: 기존 구매정보 보존, 없으면 새로 생성
            for (var e of processedData) {
                if (e.구매정보.length > 0 && !e.구매정보.find(f => f.매칭상태 !== '매칭완료' || f.요청사항 !== '등록완료')) {
                    e.구매정보여부 = true;
                } else {
                    e.구매정보여부 = false;
                    if (e.구매정보 && e.구매정보.length > 0) {
                        // 기존 구매정보가 있으면 메타데이터만 업데이트
                        e.구매정보.forEach(f => {
                            f.상품명 = e.상품명;
                            f.상품명init = e.상품명;
                            f.등록이미지 = f.등록이미지 || e.썸네일;
                            f.바코드 = f.바코드 || e.바코드;
                            if (f.한글표시사항) {
                                f.한글표시사항.제품명 = e.상품명;
                            }
                            f.요청내역 = f.요청내역 || {};
                            f.요청내역.customsType = f.요청내역.customsType || 'integrated';
                            f.요청내역.deliveryType = f.요청내역.deliveryType || 'coupang-shipment';
                        });
                    } else {
                        // 구매정보가 없으면 새로 생성
                        e.구매정보 = [{
                            checked: false,
                            showspinner: false,
                            바코드: e.바코드,
                            상품명: e.상품명,
                            상품명init: e.상품명,
                            구매링크: undefined,
                            구매링크init: undefined,
                            옵션1_중국어: undefined,
                            옵션2_중국어: undefined,
                            옵션이미지: undefined,
                            매칭상태: '매칭필요',
                            상품매칭: {
                                옵션1_중국어: [],
                                옵션2_중국어: [],
                            },
                            구매재고: '',
                            구매요청수량: '',
                            판매구성수량: 1,
                            묶음구성여부: false,
                            묶음구성수량: '',
                            묶음대상바코드: '',
                            신고영문명: '',
                            신고가격: '',
                            HSCODE: '',
                            진행현황: '구매전',
                            재고동봉: true,
                            등록이미지: e.썸네일,
                            요청사항: '요청등록',
                            reqtype: '로켓배송',
                            요청내역: {
                                default: true,
                                poarrange: false,
                                한글표시사항: true,
                                barcode: true,
                                sticker: false,
                                stamp: false,
                                tag: false,
                                reqcontent: '',
                                reqcontentPurchase: '',
                                opp: false,
                                LDPE: false,
                                airpacking: false,
                                exportType: 'box',
                                masking: false,
                                destination: 'coupang',
                                deliveryType: 'coupang-shipment',
                                auto: true,
                                customsType: 'integrated'
                            },
                            한글표시사항: {
                                제품명: e.상품명,
                                '수입원/판매원': '',
                                제조원: '',
                                제조국: '',
                                내용량: '',
                                '원료명및성분명(재질)': '',
                                상품유형: '',
                                사용시주의사항: '',
                                사용기준: '',
                                custom: '',
                                kc인증: false,
                                식품용: false,
                            },
                            polists: [],
                            selectpo: '',
                        }];
                    }
                }
            }

            // 계산된 필드 추가 + 재고 내림차순 정렬
            this.productLists = this.addCalculatedFields(processedData);
            this.productLists.sort((a, b) => (b.재고 || 0) - (a.재고 || 0));
            this.productListsinit = this.deepClone(this.productLists);
            this.calculateCounts();
        },

        calculateCounts() {
            this.total = this.productListsinit.length
            this.발주불가 = this.productListsinit.filter(item => item.발주가능상태 !== '정상').length
            this.바코드없음 = this.productListsinit.filter(item => !item.바코드).length
            this.제품분류없음 = this.productListsinit.filter(item => !item.제품분류).length
            this.구매정보없음 = this.productListsinit.filter(item => !item.구매정보여부).length
            this.매입정보없음 = this.productListsinit.filter(item => !item.latestImportPrice || item.latestImportPrice <= 0).length
            this.발주가능상태목록 = [...new Set(this.productListsinit.map(item => item.발주가능상태).filter(Boolean))]
            this.아이템루저 = this.productListsinit.filter(e => e.winner == 'LOSER').length

            // 7일 이내 노출ID 변경된 상품 수
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
            this.노출ID변경 = this.productListsinit.filter(e => {
                if (!e.productIdHistory || e.productIdHistory.length === 0) return false;
                return e.productIdHistory.some(history => new Date(history.date) >= sevenDaysAgo);
            }).length

            // 7일 이내 공급가 변경된 상품 수
            this.공급가변경 = this.productListsinit.filter(e => {
                if (!e.priceHistory || e.priceHistory.length === 0) return false;
                return e.priceHistory.some(history => new Date(history.date) >= sevenDaysAgo);
            }).length

            // 타사매칭 상품 수
            this.타사매칭 = this.productListsinit.filter(e => e.otherSellers && e.otherSellers.hasOtherSellers).length
        },

        // 필터링 메서드들
        showtotal() {
            this.productLists = [...this.productListsinit]
        },

        showOrderDisabled() {
            this.productLists = this.productListsinit.filter(item => item.발주가능상태 !== '정상')
        },

        showProductIdChanged() {
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
            this.productLists = this.productListsinit.filter(e => {
                if (!e.productIdHistory || e.productIdHistory.length === 0) return false;
                return e.productIdHistory.some(history => new Date(history.date) >= sevenDaysAgo);
            });
        },

        showPriceChanged() {
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
            this.productLists = this.productListsinit.filter(e => {
                if (!e.priceHistory || e.priceHistory.length === 0) return false;
                return e.priceHistory.some(history => new Date(history.date) >= sevenDaysAgo);
            });
        },

        // 판매가는 쿠팡 판매현황을 수집한 시점의 값이다. 수집이 멈추면 그 시점 가격이 계속 남는데
        // 화면에는 기준일이 없어 최신 가격으로 오해된다(2026-09-02 문의). 8일 이상이면 낡은 것으로 본다.
        판매가경과일(item) {
            if (!item || !item.판매가기준일) return null;
            const 기준 = new Date(item.판매가기준일);
            if (isNaN(기준.getTime())) return null;
            return Math.floor((new Date() - 기준) / 86400000);
        },

        판매가낡음(item) {
            const d = this.판매가경과일(item);
            return d !== null && d > 7;
        },

        판매가기준일표시(item) {
            const d = this.판매가경과일(item);
            if (d === null) return '';
            const 기준 = new Date(item.판매가기준일);
            const 날짜 = (기준.getMonth() + 1) + '/' + 기준.getDate();
            if (d <= 1) return 날짜 + ' 기준';
            return 날짜 + ' 기준 (' + d + '일 전)';
        },

        판매가기준일툴팁(item) {
            const d = this.판매가경과일(item);
            if (d === null) return '';
            if (d > 7) {
                return '쿠팡 판매현황을 마지막으로 수집한 ' + item.판매가기준일 + ' 시점의 판매가입니다. '
                    + d + '일이 지나 지금 쿠팡 가격과 다를 수 있고, 마진·ROI도 이 값으로 계산됩니다.';
            }
            return item.판매가기준일 + ' 수집분';
        },

        priceHistoryTitle(item) {
            if (!item.priceHistory || item.priceHistory.length === 0) return '';
            const sorted = [...item.priceHistory].sort((a, b) => new Date(a.date) - new Date(b.date));
            const latest = sorted[sorted.length - 1];
            const changeDate = new Date(latest.date).toLocaleDateString('ko-KR', { month: 'short', day: 'numeric' });
            return `공급가 변경: ${(latest.price || 0).toLocaleString()}원 → ${(item.공급가 || 0).toLocaleString()}원 (${changeDate})`;
        },

        showMatching() {
            this.productLists = this.productListsinit.filter(e => e.otherSellers && e.otherSellers.hasOtherSellers);
        },

        showItemLoser() {
            this.productLists = this.productListsinit.filter(e => e.winner == 'LOSER');
        },

        showVendorNameModal() {
            const settings = this.$store.state.settings;
            if (settings && settings.length > 0 && settings[0].rocketAllowedVendorNames) {
                this.currentAllowedVendorNames = settings[0].rocketAllowedVendorNames;
                this.allowedVendorNamesText = this.currentAllowedVendorNames.join(', ');
            }
            this.$bvModal.show('rocketVendorNameModal');
        },

        async saveRocketAllowedVendorNames(event) {
            event.preventDefault();
            const vendorNames = this.allowedVendorNamesText
                .split(',')
                .map(name => name.trim())
                .filter(name => name.length > 0);
            try {
                const result = await axios.post('/api/saveRocketAllowedVendorNames', {
                    rocketAllowedVendorNames: vendorNames
                });
                if (result.data.요청결과 === '저장완료') {
                    this.$store.commit('settingsupdateparameter', {
                        key: 'rocketAllowedVendorNames',
                        value: vendorNames
                    });
                    this.currentAllowedVendorNames = vendorNames;
                    alert('허용 스토어가 저장되었습니다.');
                    this.$bvModal.hide('rocketVendorNameModal');
                } else {
                    alert('저장 실패: ' + result.data.요청결과);
                }
            } catch (error) {
                console.error('허용 스토어 저장 오류:', error);
                alert('저장 중 오류가 발생했습니다.');
            }
        },

        cancelVendorNameModal() {
            // reset text to current saved values
            this.allowedVendorNamesText = this.currentAllowedVendorNames.join(', ');
        },

        showNoBarcodes() {
            this.productLists = this.productListsinit.filter(item => !item.바코드)
        },

        showNoCategory() {
            this.productLists = this.productListsinit.filter(item => !item.제품분류)
        },

        showd() {
            this.productLists = this.productListsinit.filter(item => !item.구매정보여부)
        },

        showe() {
            this.productLists = this.productListsinit.filter(item => !item.latestImportPrice || item.latestImportPrice <= 0)
        },

        filterByOrderStatus(status) {
            if (status === 'all') {
                this.productLists = [...this.productListsinit]
            } else {
                this.productLists = this.productListsinit.filter(item => item.발주가능상태 === status)
            }
        },

        // 로켓배송용 추가 메서드들
        classCostInfo(item) {
            return item.매입단가 ? 'success' : 'secondary'
        },

        async saveCostInfo(event, item) {
            event.preventDefault()
            try {
                const updateData = {
                    'SKU ID': item.SKUID,
                    매입단가: item.매입단가,
                    공급가액: item.공급가액,
                    부가세액: item.부가세액
                }

                await axios.post('/api/addproduct/editproductdb', updateData)

                // 로컬 데이터 업데이트
                const index = this.productListsinit.findIndex(p => p.SKUID === item.SKUID)
                if (index !== -1) {
                    this.productListsinit[index].매입단가 = item.매입단가
                    this.productListsinit[index].공급가액 = item.공급가액
                    this.productListsinit[index].부가세액 = item.부가세액
                    this.productLists = [...this.productListsinit]
                    this.calculateCounts()
                }

                alert('매입정보가 저장되었습니다.')
            } catch (error) {
                console.error('매입정보 저장 실패:', error)
                alert('매입정보 저장에 실패했습니다.')
            }
        },


        cancelPurchaseInfo($event, item) {
            $event.preventDefault()
            item.구매정보여부 = this.productListsinit.find(e => e._id == item._id).구매정보여부;
            item.구매정보 = this.productListsinit.find(e => e._id == item._id).구매정보;
            this.구매정보없음 = this.productLists.filter(e => !e.구매정보여부).length;
            this.구매정보있음 = this.productLists.filter(e => e.구매정보여부).length;
            this.$nextTick(() => {
                this.$bvModal.hide('modalpurchase' + item._id);
            })
        },
        async savePurchaseInfo($event, item) {
            $event.preventDefault()
            // this.showlist = false;
            var 현재구매정보여부 = this.productListsinit.find(e => e._id == item._id).구매정보여부;
            var 현재구매정보 = this.productListsinit.find(e => e._id == item._id).구매정보;

            if (item.구매정보 && item.구매정보.length > 0) {
                var p = this.deepClone(item.구매정보[0]);
                var par = ['매칭상태', '옵션이미지', '상품매칭', '구매링크', '구매링크init', '구매재고', '등록이미지', '옵션이미지', '옵션1_중국어', '옵션2_중국어', '구매sku', '판매구성수량', 'item']
                for (var i = 1; i < item.구매정보.length; i++) {
                    Object.keys(item.구매정보[i]).forEach(e => {
                        if (!par.includes(e)) {
                            item.구매정보[i][e] = p[e];
                        }
                    })
                }
            }


            if (!item.구매정보 || item.구매정보.length == 0 || item.구매정보.find(e => e.매칭상태 !== '매칭완료' || e.요청사항 !== '등록완료')) {
                var 구매정보여부 = false
            } else {
                구매정보여부 = true;
            }

            this.productListsinit.find(e => e._id == item._id).구매정보여부 = 구매정보여부;
            this.productListsinit.find(e => e._id == item._id).구매정보 = item.구매정보;
            item.구매정보여부 = 구매정보여부;

            console.log(item.구매정보)
            console.log(item)
            console.log(this.productListsinit.filter(e => e.노출ID == item.노출ID && e.구매정보.find(f => f.요청사항 !== "등록완료")))
            console.log(this.productListsinit.filter(e => e.구매정보.find(f => f.요청사항 !== "등록완료")))




            if (구매정보여부 && this.productListsinit.filter(e => e.노출ID == item.노출ID && e.구매정보.find(f => f.요청사항 !== "등록완료")).length > 0) {
                if (confirm('현재 구매정보를 동일한 노출ID에 모두 적용하시겠습니까? 적용대상 : ' + this.productListsinit.filter(e => e.노출ID == item.노출ID).length + '개')) {
                    var cnt = 0;
                    for (var e of this.productListsinit.filter(e => e.노출ID == item.노출ID)) {
                        if (e.바코드 !== item.바코드) {
                            console.log(e)
                            e.구매정보여부 = false;
                            e.구매정보 = [];
                            for (i = 0; i < item.구매정보.length; i++) {
                                e.구매정보[i] = this.deepClone(item.구매정보[i])
                            }
                            for (i = 0; i < e.구매정보.length; i++) {
                                var f = e.구매정보[i];
                                console.log(e.구매정보)
                                f.바코드 = e.바코드;
                                f.상품명 = e.상품명;
                                f.상품명init = e.상품명;
                                f.등록이미지 = e.썸네일;
                                f.한글표시사항.제품명 = e.상품명;
                                f.옵션이미지 = undefined;

                                f.옵션1_중국어 = f.상품매칭.옵션1_중국어.length > 0 ? undefined : "";
                                f.옵션2_중국어 = f.상품매칭.옵션2_중국어.length > 0 ? undefined : "";

                                if (f.옵션1_중국어 == undefined || f.옵션2_중국어 == undefined) {
                                    f.매칭상태 = "매칭필요";
                                } else {
                                    f.매칭상태 = "매칭완료";
                                }
                            }
                        }
                        var res = await this.saveImportInfo(e, false);
                        if (res) {
                            cnt++
                            this.$store.commit('growthdbupdateOne', e);
                        }
                        this.구매정보없음 = this.productLists.filter(e => !e.구매정보여부).length;
                        this.구매정보있음 = this.productLists.filter(e => e.구매정보여부).length;
                    }
                    alert(cnt + '개 상품 적용완료')
                } else {
                    res = await this.saveImportInfo(item, true);
                    if (!res) {
                        this.productListsinit.find(e => e._id == item._id).구매정보여부 = 현재구매정보여부;
                        this.productListsinit.find(e => e._id == item._id).구매정보 = 현재구매정보;
                        item.구매정보여부 = 현재구매정보여부;
                        item.구매정보 = 현재구매정보;
                    } else {
                        this.$store.commit('growthdbupdateOne', item);
                    }
                    this.구매정보없음 = this.productLists.filter(e => !e.구매정보여부).length;
                    this.구매정보있음 = this.productLists.filter(e => e.구매정보여부).length;
                }
            } else {
                res = await this.saveImportInfo(item, true);
                if (!res) {
                    this.productListsinit.find(e => e._id == item._id).구매정보여부 = 현재구매정보여부;
                    this.productListsinit.find(e => e._id == item._id).구매정보 = 현재구매정보;
                    item.구매정보여부 = 현재구매정보여부;
                    item.구매정보 = 현재구매정보;
                } else {
                    this.$store.commit('growthdbupdateOne', item);
                }
                this.구매정보없음 = this.productLists.filter(e => !e.구매정보여부).length;
                this.구매정보있음 = this.productLists.filter(e => e.구매정보여부).length;
            }
            this.$bvModal.hide('modalpurchase' + item._id);
            // this.showlist = true;
            // this.$nextTick(() => {
            //     this.searchResult(this.$store.state.growthdb);
            // })

        },
        classPurchaseInfo(item) {
            if (item.구매정보여부) {
                return 'success'
            } else {
                return 'secondary'
            }
        },
        async copyReq(lists) {
            console.log(lists[0])
            var newObj = this.deepClone(lists[0]);
            if (newObj.상품매칭.옵션1_중국어.length > 0) {
                newObj.옵션1_중국어 = undefined;
            } else {
                newObj.옵션1_중국어 = '';
            }
            if (newObj.상품매칭.옵션2_중국어.length > 0) {
                newObj.옵션2_중국어 = undefined;
            } else {
                newObj.옵션2_중국어 = '';
            }
            newObj.상품명init = newObj.상품명
            newObj.옵션이미지 = undefined;
            newObj.매칭상태 = '매칭필요';
            if (!newObj.요청내역.destination) {
                newObj.요청내역.destination = 'coupang'
            }
            if (!newObj.요청내역.customsType) {
                newObj.요청내역.customsType = 'integrated'
            }
            if (!newObj.요청내역.deliveryType) {
                newObj.요청내역.deliveryType = 'coupang-shipment'
            }
            lists.forEach(e => {
                e.묶음구성여부 = true;
                e.묶음구성수량 = lists.length + 1;
            })
            lists.push(newObj);
        },
        addProductName(list) {
            list.상품명 = list.상품명init;
        },

        // 구매정보 관련 메서드들
        addPurchaseInfo(item) {
            const obj = {
                checked: false,
                showspinner: false,
                바코드: item.바코드,
                상품명: item.상품명,
                상품명init: item.상품명,
                등록이미지: item.썸네일,
                구매링크: '',
                구매링크init: '',
                옵션1_중국어: '',
                옵션2_중국어: '',
                판매구성수량: 1,
                구매요청수량: 0,
                매칭상태: '매칭대기',
                요청사항: '등록대기',
                신고영문명: '',
                HSCODE: '',
                협의총금액: 0,
                협의ID: '',
                묶음구성여부: false,
                묶음구성수량: 1,
                요청내역: {
                    customsType: 'integrated',
                    destination: 'coupang',
                    deliveryType: 'coupang-shipment',
                    exportType: 'box',
                    default: true,
                    barcode: false,
                    sticker: false,
                    masking: false,
                    airpacking: false,
                    sewing: false,
                    stamp: false,
                    tag: false,
                    reqcontent: '',
                    reqcontentPurchase: ''
                },
                한글표시사항: {
                    제품명: item.상품명,
                    '수입원/판매원': '',
                    제조원: '',
                    제조국: '',
                    내용량: '',
                    '원료명및성분명(재질)': '',
                    상품유형: '',
                    사용시주의사항: '',
                    사용기준: '',
                    custom: '',
                    kc인증: false,
                    식품용: false,
                }
            };
            if (!item.구매정보) {
                item.구매정보 = [];
            }
            item.구매정보.push(obj);
        },

        deletePurchaseInfo(item, index) {
            if (confirm('정말 삭제하시겠습니까?')) {
                item.구매정보.splice(index, 1);
            }
        },

        // 매입정보 관련 메서드들 (growthdb.vue 스타일)



        editImport() {
            this.editmode = !this.editmode;
        },

        changeImportInfo(event) {
            if (event.keyCode === 13) {
                this.editmode = false;
            }
        },



        // 매입정보 관련 메서드들
        async saveImport($event, item) {
            $event.preventDefault();

            // latestImportPrice 재계산
            item.latestImportPrice = this.calculateLatestImportPrice(item.매입정보);

            // PurchaseDB에 저장
            const success = await this.saveImportInfo(item, true);
            if (success) {
                // 마진 재계산
                this.changeCost(item);
                this.changeMargin(item);
                // 매입정보없음 카운트 갱신
                this.매입정보없음 = this.productListsinit.filter(e => !e.latestImportPrice || e.latestImportPrice <= 0).length;
            }
        },





        async deleteImport(productList, index) {
            if (!confirm('이 매입정보를 삭제하시겠습니까?')) return;

            try {
                // 매입정보에서 해당 항목 삭제
                productList.매입정보.splice(index, 1);

                // 서버에 저장
                const success = await this.saveImportInfo(productList, false);
                if (success) {
                    // latestImportPrice 재계산
                    productList.latestImportPrice = this.calculateLatestImportPrice(productList.매입정보);

                    // 마진 재계산
                    this.changeCost(productList);
                    this.changeMargin(productList);

                    // 매입정보 없는 상품 수 업데이트
                    this.매입정보없음 = this.productLists.filter(e => !e.매입가).length;

                    alert('삭제되었습니다.');
                } else {
                    alert('삭제 실패');
                }
            } catch (error) {
                console.error('매입정보 삭제 오류:', error);
                alert('삭제 중 오류가 발생했습니다.');
            }
        },

        confirmBarcode(list) {
            if (list.바코드.includes('no') || list.바코드.includes('NO') || list.바코드.includes('No') || list.바코드.includes('노')) {
                if (list.묶음구성여부) {
                    alert('바코드 정보가 없는 경우 묶음구성 진행이 어렵습니다. 바코드를 먼저 생성해 주세요')
                    return
                }
            }
        },
        async importHideProducts() {
            this.showHideProducts = false;
            this.showspinner2 = true;
            if (this.searchProducts.length == 0) {
                try {
                    var res = await axios.post('/api/getGrowthDBV2', { show: false });
                    this.searchProducts = res.data.growthdb;
                    console.log(this.searchProducts)
                    // this.$store.commit('growthdbupdate', result.data.growthdb);
                    // this.searchResult(this.$store.state.growthdb);
                    this.showHideProducts = true;
                    this.showspinner2 = false;
                } catch (e) {
                    alert('불러오기 실패')
                    console.log(e)
                }
            } else {
                // alert('수집된 상품DB가 없습니다. 로켓그로스 상품DB 수집을 진행해 주세요.(쿠팡wing 로그인 필수)')
                // this.searchResult(this.$store.state.growthdb);
                this.showHideProducts = true;
                this.showspinner2 = false;
            }
        },
        cancelImport(item) {
            item.매입정보 = this.productListsinit.find(e => e._id == item._id).매입정보;
            this.changeCost(item);
            this.changeMargin(item);
            this.매입정보없음 = this.productLists.filter(e => !e.매입가).length;
            this.$nextTick(() => {
                this.$bvModal.hide('modalImport' + item._id);
            })
        },
        changeCost(item) {
            if (item.매입정보 && item.매입정보.length > 0) {
                item.매입가 = parseInt(item.매입정보[item.매입정보.length - 1].매입가);
                if (item.returnProducts && item.returnProducts.length > 0) {
                    for (var returnProd of item.returnProducts) {
                        returnProd.매입가 = parseInt(item.매입정보[item.매입정보.length - 1].매입가);
                    }
                }
                if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
                    for (var bundleProd of item.upBundlingProducts) {
                        const bundleSize = bundleProd.upBundlingSize || 1;
                        bundleProd.매입가 = parseInt(item.매입정보[item.매입정보.length - 1].매입가) * bundleSize;
                    }
                }
            } else {
                item.매입가 = "";
                if (item.returnProducts && item.returnProducts.length > 0) {
                    for (var returnProd2 of item.returnProducts) {
                        returnProd2.매입가 = "";
                    }
                }
                if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
                    for (var bundleProd2 of item.upBundlingProducts) {
                        bundleProd2.매입가 = "";
                    }
                }
            }
        },
        changeMargin(item) {
            if (item.매입가 && item.공급가) {
                // 마진 = (공급가 - 매입가) - 부가세((공급가-매입가)/11)
                item.마진 = Math.round((item.공급가 - item.매입가) * 10 / 11);
                item.마진율 = (item.공급가 > 0) ? ((item.공급가 - item.매입가) * 10 / 11 / item.공급가 * 100) : 0;
                item.ROI = (item.매입가 > 0) ? (item.마진 / (item.매입가 * 10 / 11) * 100) : 0;
                item.최소ROAS = (item.마진 > 0 && item.공급가 > 0) ? (item.공급가 / item.마진) : 0;
            }
            if (item.returnProducts && item.returnProducts.length > 0) {
                for (var retProd of item.returnProducts) {
                    if (retProd.매입가 && retProd.공급가) {
                        retProd.마진 = Math.round((retProd.공급가 - retProd.매입가) * 10 / 11);
                        retProd.마진율 = (retProd.공급가 > 0) ? ((retProd.공급가 - retProd.매입가) * 10 / 11 / retProd.공급가 * 100) : 0;
                        retProd.ROI = (retProd.매입가 > 0) ? (retProd.마진 / (retProd.매입가 * 10 / 11) * 100) : 0;
                        retProd.최소ROAS = (retProd.마진 > 0 && retProd.공급가 > 0) ? (retProd.공급가 / retProd.마진) : 0;
                    }
                }
            }
            if (item.upBundlingProducts && item.upBundlingProducts.length > 0) {
                for (var bunProd of item.upBundlingProducts) {
                    if (bunProd.매입가 && bunProd.공급가) {
                        bunProd.마진 = Math.round((bunProd.공급가 - bunProd.매입가) * 10 / 11);
                        bunProd.마진율 = (bunProd.공급가 > 0) ? ((bunProd.공급가 - bunProd.매입가) * 10 / 11 / bunProd.공급가 * 100) : 0;
                        bunProd.ROI = (bunProd.매입가 > 0) ? (bunProd.마진 / (bunProd.매입가 * 10 / 11) * 100) : 0;
                        bunProd.최소ROAS = (bunProd.마진 > 0 && bunProd.공급가 > 0) ? (bunProd.공급가 / bunProd.마진) : 0;
                    }
                }
            }
            // if(item.vendorItemId == 89848208206){
            //     console.log(item)
            // }
            // console.log(item)
        },
        formatDate(date) {
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        getTodaywith() {
            var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);
            return year + "-" + month + "-" + day;
        },
        async addImportInfo(productList) {
            this.showImport = false;
            if (productList.매입정보) {
                productList.매입정보.push({
                    date: this.getTodaywith(),
                    매입가: 0,
                })
            } else {
                productList.매입정보 = [{
                    date: this.getTodaywith(),
                    매입가: 0,
                }]
            }

            // latestImportPrice 재계산
            productList.latestImportPrice = this.calculateLatestImportPrice(productList.매입정보);

            // PurchaseDB에 저장
            await this.saveImportInfo(productList, false);

            setTimeout(() => {
                this.showImport = true;
                this.editmode = true;
            }, 1)
        },
        async calMargin(productList) {
            this.showlist = false;
            if (productList.매입가 && productList.매입가 > 0) {
                var 부가세 = productList.판매가 / 11 - productList.수수료 / 11 - productList.매입가 / 11
                productList.마진 = parseInt(productList.판매가 - productList.매입가 - productList.수수료 - 부가세);
                productList.마진율 = Math.round((productList.판매가 - productList.매입가 - productList.수수료 - 부가세) / productList.판매가 * 100 * 10) / 10
                productList.ROI = Math.round((productList.판매가 - productList.매입가 - productList.수수료 - 부가세) / (productList.매입가 * 10 / 11) * 100 * 10) / 10
            } else {
                productList.마진 = '';
                productList.마진율 = '';
                productList.ROI = '';
            }
            setTimeout(() => {
                this.showlist = true;
            }, 1)
        },
        // ⚠ 이 메서드는 template 어디에도 바인딩돼 있지 않다(호출 지점 없음). 되살리기 전에 두 가지를 고칠 것.
        //   1) hideProduct 는 vendorItemId 로 매칭하는데 여기선 _id 를 보낸다 → 지금은 하나도 안 걸린다
        //   2) 이 화면의 목록은 로켓배송 Productdb 인데 hideProduct 는 로켓그로스 세 컬렉션
        //      (GrowthDB / GrowthProductDB / GrowthSales)에 숨김을 쓴다 → 저장소 자체가 맞지 않는다
        // 1)만 고쳐서 버튼에 연결하면 로켓배송 상품을 숨겼는데 로켓그로스가 숨겨지는 사고가 난다.
        async delManageItems() {
            if (this.tableSelectedItem.length == 0) {
                alert('관리삭제할 항목을 선택해 주세요')
                return
            }
            if (confirm(this.tableSelectedItem.length + '개의 항목을 관리삭제(숨김처리)하시겠습니까?')) {
                try {
                    var input = this.tableSelectedItem.map(e => e._id);
                    var res = await axios.post('/api/growthdb/hideProduct', input);
                    if (res.data.res == 'success') {
                        this.productLists = this.productLists.filter(e => !input.includes(e._id));
                        this.productListsinit = this.productListsinit.filter(e => !input.includes(e._id));
                        console.log(this.searchProducts)
                        this.searchProducts = this.searchProducts.concat(this.tableSelectedItem);
                        // productListsinit 은 이 화면(로켓배송 Productdb) 목록이라, 로켓그로스용 공용
                        // 스토어에 커밋하면 카탈로그가 통째로 뒤바뀌어 판매장부 매출이 사라진다(#407).
                        this.$store.commit('growthdbupdate', []);
                    } else {
                        alert(res.data.alert)
                    }
                } catch (e) {
                    alert('err823' + e)
                }
            }
        },
        changePackage(list) {
            if (this.packageMethod == 'opp') {
                list.요청내역.opp = true;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'LDPE') {
                list.요청내역.opp = true;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'noPackage') {
                list.요청내역.opp = false;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'auto') {
                list.요청내역.opp = false;
                list.요청내역.LDPE = false;
                list.요청내역.auto = true;
                return
            }
        },
        async addSearchProduct(list, index) {
            console.log(list)
            this.searchProducts.splice(index, 1);
            var f = list;
            // 구매정보여부 는 불리언이라 .length 가 없다 — 숨김처리취소 클릭 시 TypeError 로 죽었다(#411)
            if (!f.구매정보 || f.구매정보.length == 0) {
                var 구매정보 = [{
                    checked: false,
                    showspinner: false,
                    // SKUID : '',
                    바코드: f.barcode,
                    상품명: f.productName,
                    상품명init: f.productName,
                    구매링크: undefined,
                    구매링크init: undefined,
                    옵션1_중국어: undefined,
                    옵션2_중국어: undefined,
                    옵션이미지: undefined,
                    매칭상태: '매칭필요',
                    상품매칭: {
                        옵션1_중국어: [],
                        옵션2_중국어: [],
                    },
                    구매재고: '',
                    구매요청수량: '',
                    판매구성수량: 1,
                    묶음구성여부: false,
                    묶음구성수량: '',
                    묶음대상바코드: '',
                    신고영문명: '',
                    신고가격: '',
                    HSCODE: '',
                    진행현황: '구매전',
                    재고동봉: true,
                    등록이미지: f.optionImageUrl,
                    요청사항: '요청등록',
                    reqtype: '제트배송',
                    sizeX: f.sizeInfo ? f.sizeInfo.width : 0,
                    sizeY: f.sizeInfo ? f.sizeInfo.length : 0,
                    sizeZ: f.sizeInfo ? f.sizeInfo.heigth : 0,
                    weight: f.sizeInfo ? f.sizeInfo.weight : 0,
                    요청내역: {
                        default: true,
                        poarrange: false,
                        한글표시사항: true,
                        barcode: true,
                        sticker: false,
                        stamp: false,
                        tag: false,
                        reqcontent: '',
                        reqcontentPurchase: '',
                        opp: false,
                        LDPE: false,
                        airpacking: false,
                        exportType: 'box',

                        masking: false,
                        destination: 'coupang',
                        auto: true,
                        customsType: 'integrated',
                    },
                    한글표시사항: {
                        제품명: f.productName,
                        '수입원/판매원': '쿠플러스',
                        제조원: '',
                        제조국: '',
                        내용량: '',
                        '원료명및성분명(재질)': '',
                        상품유형: '',
                        사용시주의사항: '',
                        사용기준: '',
                        custom: '',
                        kc인증: false,
                        식품용: false,
                    },
                    polists: [],
                    selectpo: '',
                }];
                var 구매정보여부 = false
            }
            var obj = {
                _id: f._id,
                상품명: f.상품명 ? f.상품명 : f.productName,
                바코드: f.바코드 ? f.바코드 : f.barcode,
                노출ID: f.노출ID ? f.노출ID : f.productId,
                옵션ID: f.옵션ID ? f.옵션ID : f.vendorItemId,
                승인상태: f.승인상태 ? f.승인상태 : f.statusName,
                옵션이미지: f.옵션이미지 ? f.옵션이미지 : f.optionImageUrl,

                구매정보: f.구매정보 || 구매정보,
                구매정보여부: f.구매정보여부 || 구매정보여부,
                판매링크: f.판매링크 ? f.판매링크 : 'https://www.coupang.com/vp/products/' + f.productId + '?vendorItemId=' + f.vendorItemId,
                아이템위너: f.아이템위너 ? f.아이템위너 : f.winner,
                뱃지: f.뱃지 ? f.뱃지 : f.badge,
                // 목록·뱃지·표 컬럼은 전부 원본 필드명(winner/badge)을 읽는다. 한글 이름만
                // 담으면 복원된 행이 집계에서 통째로 빠지고 표에서도 빈칸으로 보인다.
                winner: f.winner ? f.winner : f.아이템위너,
                badge: f.badge ? f.badge : f.뱃지,

                사이즈: f.사이즈 ? f.사이즈 : f.size,
                사이즈정보: f.사이즈정보 ? f.사이즈정보 : f.sizeInfo,
                판매가: f.판매가 ? f.판매가 : f.salePrice,

                풀필먼트수수료: f.풀필먼트수수료 ? f.풀필먼트수수료 : f.fullfillmentFee,
                입출고수수료: f.입출고수수료 ? f.입출고수수료 : f.warehouseFee,
                판매수수료: f.판매수수료 ? f.판매수수료 : f.commision,
                판매수수료율: f.판매수수료율 ? f.판매수수료율 : f.commisionRate,
                수수료: f.수수료 ? f.수수료 : ((parseInt(f.fullfillmentFee) + parseInt(f.warehouseFee) + f.commision) * 1.1).toFixed(0),

                매입정보: f.매입정보 || [],
                매입가: f.매입가 || "",
                마진: f.마진 || "",
                마진율: f.마진율 || "",
                ROI: f.ROI || "",
                ROAS: f.ROAS || ""
            }

            // 뱃지 숫자는 calculateCounts 하나에서만 만든다. 예전에는 여기서 자기만의 식으로
            // 다시 셌는데, `아이템위너 == 'N'` / `뱃지 == 'N'` 은 어느 행에도 없는 값이라
            // 「숨김처리취소」를 한 번 누르면 뱃지가 0이 됐다.
            // addManage 는 서버 응답을 기다렸다가 push 하므로 await 해야 목록에 담긴 뒤에 센다.
            await this.addManage(obj);
            this.calculateCounts();
            this.구매정보있음 = this.productListsinit.filter(e => e.구매정보여부).length;
            this.showlist = true;
            this.showspinner = false;
            this.showspinner1 = false;
            // this.productList = list;
        },
        delSearchProduct(list) {
            delete list.add;
        },
        async addManage(item) {
            var vendorItemId = item.옵션ID;
            try {
                var res = await axios.post('/api/growthdb/showProduct', [vendorItemId])
                if (res.data.res == 'success') {
                    this.productLists.push(item)
                    this.productListsinit.push(this.deepClone(item))
                    // 위와 같은 이유로 좁은/다른 목록을 덮어쓰지 않고 무효화만 한다(#407).
                    this.$store.commit('growthdbupdate', []);
                } else {
                    alert(res.data.alert)
                }
            } catch (e) {
                console.log('err844' + e);
            }
        },
        delAddProduct(index) {
            this.addProducts.splice(index, 1);
        },
        confirmlist(list) {
            if (!list.바코드) {
                if (!confirm('바코드가 없는 경우 로켓그로스 출고가 불가능합니다.')) {
                    return false
                }
            }
            if (!list.신고영문명) {
                alert("요청내역 중 신고영문명을 작성해주세요. ex)여성신발 -> women's shoes ")
                return false
            }
            // if(!list.신고가격){
            //     alert("요청내역 중 신고가격을 USD로 환산하여 작성해주세요. ex) 2달러 -> 2 ")
            //     return false
            // }            
            if (!list.HSCODE) {
                alert("요청내역 중 HS-CODE를 작성해주세요. ex) 6303.92-0000 ")
                return false
            }
            if (list.HSCODE.length !== 12) {
                alert("HS-CODE를 Full name으로 작성해주세요. ex) 6303.92-0000 ")
                return false
            }
            if (list.구매요청수량 == 0 || !list.구매요청수량) {
                alert("구매요청수량을 작성해 주세요.")
                return false
            }
            if (list.판매구성수량 == 0 || !list.판매구성수량) {
                alert("판매구성수량을 작성해 주세요.")
                return false
            }
            list.한글표시사항.제품명 = list.상품명;
            // 필수 텍스트 항목만 화이트리스트로 검사 (kc인증/식품용 등 boolean·선택 키가 추가돼도 오탐 안 나게)
            var 필수표시항목 = ['수입원/판매원', '제조원', '제조국', '내용량', '원료명및성분명(재질)', '상품유형', '사용시주의사항', '사용기준'];
            if (필수표시항목.some(k => !list.한글표시사항[k])) {
                console.log(list.한글표시사항)
                alert('한글표시사항을 모두 작성해 주세요')
                return false
            }
            return true
        },

        // regrequest(_list, _index){
        //     if(!_list.상품명){
        //         alert('상품명을 먼저 입력해 주세요')
        //         return
        //     }
        //     this.$bvModal.show('modalreq' + _index);
        // },
        async addlists(item) {
            var obj = {
                checked: false,
                showspinner: false,
                // SKUID : '',
                바코드: item.바코드,
                상품명: item.상품명,
                상품명init: item.상품명,
                구매링크: undefined,
                구매링크init: undefined,
                옵션1_중국어: undefined,
                옵션2_중국어: undefined,
                옵션이미지: undefined,
                매칭상태: '매칭필요',
                상품매칭: {
                    옵션1_중국어: [],
                    옵션2_중국어: [],
                },
                구매재고: '',
                구매요청수량: '',
                판매구성수량: 1,
                묶음구성여부: false,
                묶음구성수량: '',
                묶음대상바코드: '',
                신고영문명: '',
                신고가격: '',
                HSCODE: '',
                진행현황: '구매전',
                재고동봉: true,
                등록이미지: item.옵션이미지,
                요청사항: '요청등록',
                reqtype: '제트배송',
                sizeX: item.sizeInfo ? item.sizeInfo.width : "",
                sizeY: item.sizeInfo ? item.sizeInfo.length : "",
                sizeZ: item.sizeInfo ? item.sizeInfo.heigth : "",
                weight: item.sizeInfo ? item.sizeInfo.weight : "",
                요청내역: {
                    default: true,
                    poarrange: false,

                    한글표시사항: true,
                    barcode: true,
                    sticker: false,
                    sewing: false,
                    stamp: false,
                    tag: false,
                    reqcontent: '',
                    reqcontentPurchase: '',
                    opp: false,
                    LDPE: false,
                    airpacking: false,
                    exportType: 'box',
                    destination: 'coupang',
                    masking: false,
                    auto: true,
                    customsType: 'integrated'
                },
                한글표시사항: {
                    제품명: item.상품명,
                    '수입원/판매원': '쿠플러스',
                    제조원: '',
                    제조국: '',
                    내용량: '',
                    '원료명및성분명(재질)': '',
                    상품유형: '',
                    사용시주의사항: '',
                    사용기준: '',
                    custom: '',
                    kc인증: false,
                    식품용: false,
                },
                polists: [],
                selectpo: '',
            }
            item.구매정보.push(obj)
        },
        toggleCollapse(item) {
            if (this.isCollapseOpen) {
                this.purchaseItem.purchaseInfoLists = [];
            } else {
                this.purchaseItem = this.deepClone(item);
            }
            this.isCollapseOpen = !this.isCollapseOpen;
        },
        deepClone(obj) {
            if (obj === null || typeof obj !== "object") {
                return obj
            }

            const result = Array.isArray(obj) ? [] : {}

            for (let key of Object.keys(obj)) {
                result[key] = this.deepClone(obj[key])
            }

            return result
        },
        updateProductDb() {
            this.showspinner1 = true
            this.loadingtext = 'SKU 리스트 수집 중... (수집 완료 시 자동으로 업데이트됩니다)'
            const settings = this.$store.state.settings;
            const allowedVendorNames = (settings && settings.length > 0 && settings[0].rocketAllowedVendorNames) ? settings[0].rocketAllowedVendorNames : [];
            window.postMessage({
                greeting: "manualCollect",
                itemKey: "rocketDeliverySKU",
                companyid: this.$store.state.user.companyid,
                suppliercode: this.$store.state.user.suppliercode,
                options: { allowedVendorNames }
            }, "*")
        },
        excelDownFunc() {
            var arr = JSON.parse(JSON.stringify(this.productLists))
            arr.forEach(e => {
                if (e._id) { delete e._id }
                // 매입정보 관련 필드 정리
                if (!e.매입단가) e.매입단가 = 0;
                if (!e.공급가액) e.공급가액 = 0;
                if (!e.부가세액) e.부가세액 = 0;
                if (!e.총매입가) e.총매입가 = 0;
            })

            const myHeader = ["상품명", "SKUID", "바코드", "제품분류", "발주가능상태", "구매링크", "옵션1_중국어", "옵션2_중국어", "판매구성수량", "매입단가", "공급가액", "부가세액", "총매입가", "썸네일"];
            var dataWS = XLSX.utils.json_to_sheet(arr, { header: myHeader });

            const range = XLSX.utils.decode_range(dataWS['!ref']);
            range.e['c'] = myHeader.length - 1;
            dataWS['!ref'] = XLSX.utils.encode_range(range);

            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, dataWS, '로켓배송상품DB');
            // 엑셀 파일을 내보낸다.
            XLSX.writeFile(wb, '로켓배송상품DB.xlsx');
        },
        excelDateToJSDate(excelDate) {
            // 엑셀 날짜를 기준으로 변환 (엑셀은 1900-01-01 기준이며, JavaScript는 1970-01-01 기준)
            const excelEpoch = new Date(1899, 11, 30); // 1899-12-30
            const jsDate = new Date(excelEpoch.getTime() + (excelDate - 1 + 1) * 24 * 60 * 60 * 1000);
            console.log(jsDate)
            var result = this.formatDate(jsDate);
            return result;
        },
        formatDownload(type) {
            var arr = [];
            var myHeader;
            var fileName;

            if (type === 'SKUID') {
                myHeader = ["SKUID", '매입일자(2025-01-01)', '매입가'];
                fileName = "매입정보업로드양식_SKUID.xlsx";
            } else if (type === 'barcode') {
                myHeader = ["바코드", '매입일자(2025-01-01)', '매입가'];
                fileName = "매입정보업로드양식_바코드.xlsx";
            } else {
                myHeader = ["SKUID", '매입일자(2025-01-01)', '매입가'];
                fileName = "매입가업로드양식.xlsx";
            }

            var dataWS = XLSX.utils.json_to_sheet(arr, { header: myHeader });

            const range = XLSX.utils.decode_range(dataWS['!ref']);
            range.e['c'] = myHeader.length - 1;
            dataWS['!ref'] = XLSX.utils.encode_range(range);

            var wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '매입가업로드양식');
            // 엑셀 파일을 내보낸다.
            XLSX.writeFile(wb, fileName);
        },
        edit(ProductList) {
            this.$store.state.productdb.some(e => {
                if (e["SKU ID"] == ProductList["SKU ID"]) {
                    e.등록이미지 = ProductList.등록이미지;
                    e.구매링크 = ProductList.구매링크;
                    e.옵션1_중국어 = ProductList.옵션1_중국어;
                    e.옵션2_중국어 = ProductList.옵션2_중국어;
                    e.판매구성수량 = ProductList.판매구성수량;
                    e.구매가능상태 = ProductList.구매가능상태;
                    axios.post('/api/addproduct/editproductdb', ProductList)
                        .then((res) => { console.log(res.data.요청결과) })
                        .catch(console.log)
                    return (e["SKU ID"] == ProductList["SKU ID"])
                }
            })
        },
        MenuUpdate() {
            console.log(this.selected)
            if (this.selected == "radio1") {
                this.menuint = this.menuDefault;
            } else {
                if (this.selected == "radio2") {
                    this.menuint = this.menuCost;
                }
                //  else {
                //     this.menuint = this.menuSales;
                // }
            }
        },
        modalID(index) {
            return 'modal' + index
        },
        modaledit(index) {
            return 'modaledit' + index
        },
        searchpd(event) {
            if (event.keyCode === 13) {
                this.search();
            }
        },
        async search() {
            this.showlist = false;
            this.showspinner = true;
            if (this.$store.state.growthdb.length == 0) {
                try {
                    // show 없이 전량 — 좁히면 판매장부가 물려받아 숨김 상품 매출이 사라진다(#407).
                    // 여긴 목록을 실제로 그리는 경로라 표시 시점에 catalogOnly() 로 거른다.
                    var result = await axios.post('/api/getGrowthDBV2');
                    console.log(result.data.growthdb.find(e => e.매입정보 && e.매입정보.length > 0))
                    this.$store.commit('growthdbupdate', result.data.growthdb);
                    this.searchResult(this.catalogOnly(this.$store.state.growthdb));
                    this.showlist = true;
                    this.showspinner = false;
                } catch (e) {
                    alert('불러오기 실패')
                    console.log(e)
                }
            } else {
                // alert('수집된 상품DB가 없습니다. 로켓그로스 상품DB 수집을 진행해 주세요.(쿠팡wing 로그인 필수)')
                this.searchResult(this.catalogOnly(this.$store.state.growthdb));
                this.showlist = true;
                this.showspinner = false;
            }
        },
        // 공용 스토어(state.growthdb)는 판매장부가 매출 집계에 쓰므로 숨김 포함 전량을 담는다.
        // 목록을 그리는 쪽에서만 거른다 — growthdb.vue 의 catalogOnly() 와 같은 규칙이다.
        //   catalogMissing          : 매입가만 있고 카탈로그에 없는 합집합 행(상품명·썸네일이 없다)
        //   show === false          : 쿠플러스 자체 숨김 (서버가 세 컬렉션 합집합으로 판정해 채워준다)
        //   coupangHidden === true  : wing 재고현황 숨김
        catalogOnly(list) {
            return (list || []).filter(e => !e.catalogMissing && e.show !== false && e.coupangHidden !== true);
        },
        async searchResult(list) {
            console.log(list);
            this.productLists = [];
            this.productListsinit = [];
            this.searchProducts = [];

            for (var e of list) {
                if (e.구매정보.length > 0 && !e.구매정보.find(f => f.매칭상태 !== '매칭완료' || f.요청사항 !== '등록완료')) {
                    e.구매정보여부 = true;
                } else {
                    e.구매정보여부 = false;
                    if (e.구매정보 && e.구매정보.length > 0) {
                        e.구매정보.forEach(f => {
                            f.상품명 = e.skuName;
                            f.상품명init = e.skuName;
                            f.등록이미지 = f.등록이미지 || e.imgUrl;
                            f.바코드 = f.바코드 || e.barcode;
                            f.sizeX = e.skuInfo ? e.skuInfo.width : 0;
                            f.sizeY = e.skuInfo ? e.skuInfo.length : 0;
                            f.sizeZ = e.skuInfo ? e.skuInfo.heigth : 0;
                            f.weight = e.skuInfo ? e.skuInfo.weight : 0;
                            f.한글표시사항.제품명 = e.skuName;
                            f.요청내역.customsType = f.요청내역.customsType || 'integrated';
                        })
                    } else {
                        e.구매정보 = [{
                            checked: false,
                            showspinner: false,
                            // SKUID : '',
                            바코드: e.barcode,
                            상품명: e.skuName,
                            상품명init: e.skuName,
                            구매링크: undefined,
                            구매링크init: undefined,
                            옵션1_중국어: undefined,
                            옵션2_중국어: undefined,
                            옵션이미지: undefined,
                            매칭상태: '매칭필요',
                            상품매칭: {
                                옵션1_중국어: [],
                                옵션2_중국어: [],
                            },
                            구매재고: '',
                            구매요청수량: '',
                            판매구성수량: 1,
                            묶음구성여부: false,
                            묶음구성수량: '',
                            묶음대상바코드: '',
                            신고영문명: '',
                            신고가격: '',
                            HSCODE: '',
                            진행현황: '구매전',
                            재고동봉: true,
                            등록이미지: e.imgUrl,
                            요청사항: '요청등록',
                            reqtype: '로켓배송',
                            sizeX: e.skuInfo ? e.skuInfo.width : 0,
                            sizeY: e.skuInfo ? e.skuInfo.length : 0,
                            sizeZ: e.skuInfo ? e.skuInfo.heigth : 0,
                            weight: e.skuInfo ? e.skuInfo.weight : 0,
                            요청내역: {
                                default: true,
                                poarrange: false,
                                한글표시사항: true,
                                barcode: true,
                                sticker: false,
                                stamp: false,
                                tag: false,
                                reqcontent: '',
                                reqcontentPurchase: '',
                                opp: false,
                                LDPE: false,
                                airpacking: false,
                                exportType: 'box',
                                masking: false,
                                destination: 'coupang',
                                deliveryType: 'coupang-shipment',
                                auto: true,
                                customsType: 'integrated'
                            },
                            한글표시사항: {
                                제품명: e.skuName,
                                '수입원/판매원': '',
                                제조원: '',
                                제조국: '',
                                내용량: '',
                                '원료명및성분명(재질)': '',
                                상품유형: '',
                                사용시주의사항: '',
                                사용기준: '',
                                custom: '',
                                kc인증: false,
                                식품용: false,
                            },
                            polists: [],
                            selectpo: '',
                        }];
                    }
                }
            }

            this.productLists = this.deepClone(list);
            this.productListsinit = this.deepClone(list);

            // 통계 수치 계산만 여기서 수행
            this.total = this.productLists.length;
            this.뱃지없음 = this.productLists.filter(e => !e.badge).length;
            this.아이템루저 = this.productLists.filter(e => e.winner == 'LOSER').length;
            this.구매정보없음 = this.productLists.filter(e => !e.구매정보여부).length;
            this.반품정보있음 = this.productLists.filter(e => e.returnProducts && e.returnProducts.length > 0).length;
            this.번들정보있음 = this.productLists.filter(e => e.upBundlingProducts && e.upBundlingProducts.length > 0).length;
            this.구매정보있음 = this.productLists.filter(e => e.구매정보여부).length;
            this.매입정보없음 = this.productLists.filter(e => !e.매입가).length;

            this.showlist = true;
            this.showspinner = false;
            this.showspinner1 = false;
        },

        showa() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.productListsinit.filter(e => e.winner !== 'WINNER')
                this.showlist = true;
            }, 1);
        },
        showb() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.productListsinit.filter(e => !e.badge)
                this.showlist = true;
            }, 1);
        },
        showc() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.productListsinit.filter(e => e.구매정보여부)
                this.showlist = true;
            }, 1);
        },


        showf() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.productListsinit.filter(e => e.returnProducts && e.returnProducts.length > 0)
                this.showlist = true;
            }, 1);
        },
        showg() {
            this.showlist = false;
            setTimeout(() => {
                this.productLists = this.productListsinit.filter(e => e.upBundlingProducts && e.upBundlingProducts.length > 0)
                this.showlist = true;
            }, 1);
        },
        rematching(lists, list, index) {
            if (!list.구매링크) {
                alert('구매링크를 입력해 주세요')
                return
            }
            list.옵션1_중국어 = undefined;
            list.옵션2_중국어 = undefined;
            list.상품매칭.옵션1_중국어 = [];
            list.상품매칭.옵션2_중국어 = [];
            this.matchoption1(lists, index, list.구매링크)
        },
        async matchoption1(lists, index, 구매링크) {
            if (!구매링크.includes('1688.com')) {
                alert('올바른 구매링크를 입력해 주세요')
                lists[index].구매링크init = undefined;
                lists[index].구매링크 = undefined;
                return
            }
            lists[index].showspinner = true;
            lists[index].구매링크 = 구매링크;
            this.currentindex = index;
            // setTimeout(() => {this.sendmessage(구매링크);},1)
            var newObj = await this.confirmreq(lists[index]);
            // console.log(newObj)
            // this.showlist = false
            lists[index] = newObj;
            console.log(lists[this.currentindex])
            // this.showlist = true


            // axios.post('/api/reqpurchase/geturlinfo',{
            //     url : 구매링크
            // })
            // .then((res) => {
            //     if(res.data.요청결과 == 'success'){
            //         console.log(res.data.result)
            //         var obj = {}
            //         res.data.result.option1array.forEach(e => {
            //             obj = {
            //                 image : e.imageUrl,
            //                 optionname : e.name,
            //             }
            //             list.상품매칭.옵션1_중국어.push(obj)
            //         })
            //         res.data.result.option2array.forEach(e => {
            //             obj = {
            //                 image : e.imageUrl,
            //                 optionname : e.name,
            //             }
            //             list.상품매칭.옵션1_중국어.push(obj)
            //         })

            //     } else {
            //         alert('error777 :' + res.data.요청결과)
            //     }
            // })
            // .catch(console.log)
        },
        async confirmreq(obj) {
            console.log(obj)
            if (!obj.구매링크) {
                obj.showspinner = false;
                return obj
            }
            obj.구매링크init = obj.구매링크;
            obj.매칭상태 = '매칭필요'
            var item = await this.getProductInfo(obj.구매링크);
            item = item.data.result[0].result.result
            console.log(item)
            obj.item = item;

            let option1array = [];
            let option2array = [];

            if (item.productSkuInfos) {
                item.productSkuInfos.forEach((e) => {
                    if (!option1array.find(option => option.name === e.skuAttributes[0].value)) {
                        option1array.push({
                            name: e.skuAttributes[0].value,
                            imageUrl: e.skuAttributes[0].skuImageUrl ? e.skuAttributes[0].skuImageUrl : '',
                        })
                    }

                    if (e.skuAttributes[1]) {
                        if (!option2array.find(option => option.name === e.skuAttributes[1].value)) {
                            option2array.push({
                                name: e.skuAttributes[1].value,
                                imageUrl: e.skuAttributes[1].skuImageUrl ? e.skuAttributes[1].skuImageUrl : '',
                            })
                        }
                    } else {
                        option2array = []
                    }
                })
            }

            if (option1array.length === 0) {
                obj.상품매칭.옵션1_중국어 = [];
                obj.상품매칭.옵션2_중국어 = [];
                obj.옵션1_중국어 = '';
                obj.옵션2_중국어 = '';
                obj.구매재고 = item.productSaleInfo.amountOnSale;
                obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : item.productImage.images[0];
                obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : item.productImage.images[0];
                obj.매칭상태 = '매칭완료'
            } else {
                var imgUrl = '';
                if (option2array.length == 0) {
                    imgUrl = option1array.find(e => e.name == obj.옵션1_중국어) ? imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : "";
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어).amountOnSale;
                        obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : imgUrl;
                        obj.매칭상태 = '매칭완료'
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = [];
                    obj.옵션2_중국어 = '';
                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                } else {
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : option1array.find(e => e.name == obj.옵션1_중국어).imageUrl;
                        if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
                            obj.옵션2_중국어 = undefined;
                            obj.구매재고 = 0;
                        } else {
                            obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어 && f.skuAttributes[1].value == obj.옵션2_중국어).amountOnSale;
                            imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : "");
                            obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : (option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : ""));
                            obj.매칭상태 = '매칭완료'
                        }
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = option2array;
                    console.log(option1array)
                    console.log(option1array.find(e => e.name == obj.옵션1_중국어))
                    console.log(option2array)

                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                }

                if (!obj.등록이미지 && !option1array.find(e => e.imageUrl) && !option1array.find(e => e.imageUrl)) {
                    obj.등록이미지 = item.productImage.images[0];
                }
            }
            obj.showspinner = false;
            return obj
        },
        async getProductInfo(구매링크) {
            var productNo = 구매링크.slice(구매링크.search('offer/') + 6, 구매링크.search('.html'));
            try {
                var res = await axios.post('/api/aiPage/getProductInfo', [{ productId: parseInt(productNo) }])
                return res
            } catch (e) {
                console.log('err821' + e);
                return false
            }
        },
        pricechange(obj) {
            this.change = true;
            if (obj.매칭상태 == '매칭필요') {
                obj.구매가격 = '';
                return
            }
            if (obj.item && obj.구매요청수량) {
                var option1array = [];
                var option2array = [];
                var item = obj.item;
                if (item.props_list && Object.keys(item.props_list).length > 0) {
                    Object.keys(item.props_list).forEach(e => {
                        if (e[0] == '0') {
                            option1array.push({
                                properties: e,
                                name: item.props_list[e].split(":")[1],
                                imageUrl: item.props_img[e] ? item.props_img[e] : '',
                            })
                        }
                        if (e[0] == '1') {
                            option2array.push({
                                properties: e,
                                name: item.props_list[e].split(":")[1],
                                imageUrl: item.props_img[e] ? item.props_img[e] : '',
                            })
                        }
                    })
                }

                if (option1array.length == 0) {
                    if (item.priceRange) {
                        for (var i = 0; i < item.priceRange.length; i++) {
                            obj.구매가격 = parseFloat(item.priceRange[i][1]);
                            if (parseInt(item.priceRange[i][0]) > obj.구매요청수량) {
                                break
                            }
                        }
                    } else {
                        obj.구매가격 = parseInt(item.price);
                    }
                } else {
                    if (option2array.length == 0) {
                        if (item.priceRange) {
                            for (i = 0; i < item.priceRange.length; i++) {
                                obj.구매가격 = parseFloat(item.priceRange[i][1]);
                                if (parseInt(item.priceRange[i][0]) > obj.구매요청수량) {
                                    break
                                }
                            }
                        } else {
                            obj.구매가격 = parseInt(item.price);
                        }
                    } else {
                        if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                            obj.구매가격 = '';
                        } else {
                            if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
                                obj.구매가격 = '';
                            } else {
                                var option1properties = option1array.find(e => e.name == obj.옵션1_중국어).properties;
                                var option2properties = option2array.find(e => e.name == obj.옵션2_중국어).properties;
                                obj.구매가격 = parseInt(item.skus.sku.find(e => e.properties == (option1properties + ';' + option2properties)).price);
                            }
                        }
                    }
                }
            }
        },
        reset(list) {
            list.옵션1_중국어 = undefined;
            list.옵션2_중국어 = undefined;
            list.상품매칭.옵션1_중국어 = [];
            list.상품매칭.옵션2_중국어 = [];
            list.구매링크 = undefined;
            list.구매링크init = '';
        },
        deleteindexfromarray(array, index) {
            return array.slice(0, index).concat(array.slice(index + 1))
        },
        deleteitem(lists, index, f) {
            // this.showPurchase = false;
            lists.forEach(e => {
                e.묶음구성여부 = lists.length == 2 ? false : true;
                e.묶음구성수량 = lists.length == 2 ? "" : (lists.length - 1)
            })
            lists.splice(index, 1)
            console.log(lists)
            console.log(f)
            if (lists.length == 0) {
                console.log(lists.length)
                lists.push({
                    checked: false,
                    showspinner: false,
                    // SKUID : '',
                    바코드: f.바코드,
                    상품명: f.상품명,
                    상품명init: f.상품명,
                    구매링크: undefined,
                    구매링크init: undefined,
                    옵션1_중국어: undefined,
                    옵션2_중국어: undefined,
                    옵션이미지: undefined,
                    매칭상태: '매칭필요',
                    상품매칭: {
                        옵션1_중국어: [],
                        옵션2_중국어: [],
                    },
                    구매재고: '',
                    구매요청수량: '',
                    판매구성수량: 1,
                    묶음구성여부: false,
                    묶음구성수량: '',
                    묶음대상바코드: '',
                    신고영문명: '',
                    신고가격: '',
                    HSCODE: '',
                    진행현황: '구매전',
                    재고동봉: true,
                    등록이미지: f.옵션이미지,
                    요청사항: '요청등록',
                    reqtype: '제트배송',
                    sizeX: f.sizeX,
                    sizeY: f.sizeY,
                    sizeZ: f.sizeZ,
                    weight: f.weight,
                    요청내역: {
                        default: true,
                        poarrange: false,

                        한글표시사항: true,
                        barcode: true,
                        sticker: false,
                        sewing: false,
                        stamp: false,
                        tag: false,
                        reqcontent: '',
                        reqcontentPurchase: '',
                        opp: false,
                        LDPE: false,
                        airpacking: false,
                        exportType: 'box',
                        destination: 'coupang',
                        masking: false,
                        auto: true,
                        customsType: 'integrated'
                    },
                    한글표시사항: {
                        제품명: f.상품명,
                        '수입원/판매원': '쿠플러스',
                        제조원: '',
                        제조국: '',
                        내용량: '',
                        '원료명및성분명(재질)': '',
                        상품유형: '',
                        사용시주의사항: '',
                        사용기준: '',
                        custom: '',
                        kc인증: false,
                        식품용: false,
                    },
                    polists: [],
                    selectpo: '',
                })

            }
            console.log(lists)
            // lists = this.deleteindexfromarray(lists,index);
            // setTimeout(()=>{
            //     this.showPurchase = true;
            // },10)

        },

        regclass(a) {
            if (a.length > 0) {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },


        async uploadfile(event, type = 'SKUID') {
            try {
                this.showlist = false;
                this.showuploadspinner = true;
                this.currentUploadType = type;

                const file = event.target.files[0];
                if (!file) return;

                const data = await this.readFileAsync(file);
                const workbook = XLSX.read(data, { type: 'binary' });

                for (const sheetName of workbook.SheetNames) {
                    const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                    console.log(roa);

                    let cntUpdate = 0;
                    const cnt = roa.length;
                    const errorArr = [];

                    for (const e of roa) {
                        let ob;

                        if (type === 'SKUID') {
                            // SKU ID로 매칭
                            ob = this.productLists.find(ele => ele.SKUID === e.SKUID);
                            if (!ob) {
                                errorArr.push(e.SKUID);
                                continue;
                            }
                        } else if (type === 'barcode') {
                            // 바코드로 매칭
                            ob = this.productLists.find(ele => ele.바코드 === e.바코드);
                            if (!ob) {
                                errorArr.push(e.바코드);
                                continue;
                            }
                        }

                        const date = this.excelDateToJSDate(e["매입일자(2025-01-01)"]);
                        if (ob.매입정보) {
                            ob.매입정보.push({
                                date: date,
                                매입가: e.매입가,
                            });
                        } else {
                            ob.매입정보 = [{
                                date: date,
                                매입가: e.매입가,
                            }]
                        }


                        // 매입가 업데이트
                        ob.매입가 = e.매입가;

                        // DB에 저장
                        const success = await this.saveImportInfo(ob, false);
                        if (success) {
                            cntUpdate++;
                        } else {
                            errorArr.push(type === 'SKUID' ? e.SKUID : e.바코드);
                        }
                    }

                    const errorType = type === 'SKUID' ? 'SKU ID' : '바코드';
                    if (cntUpdate === cnt) {
                        alert(`매입정보 업로드가 완료되었습니다. 성공 ${cntUpdate}개 (${errorType} 방식)`);
                    } else {
                        alert(`${errorType} 매칭 업로드 완료: 성공 ${cntUpdate}개, 실패 ${errorArr.length}개\n실패: ${errorArr.join(', ')}`);
                    }
                    this.loadProductData(); // 데이터 새로고침

                    this.showuploadspinner = false;
                    this.currentUploadType = null;

                    // 업로드 상태 초기화
                    if (type === 'SKUID') {
                        this.uploadstatus = '업로드';
                    } else {
                        this.uploadstatus2 = '업로드';
                    }

                    this.$bvModal.hide('excelupload');
                }
            } catch (error) {
                alert(error.message);
                this.showuploadspinner = false;
                this.currentUploadType = null;

                // 업로드 상태 초기화
                if (type === 'vendorItemId') {
                    this.uploadstatus = '업로드';
                } else {
                    this.uploadstatus2 = '업로드';
                }

                this.$bvModal.hide('excelupload');
            }
        },
        async readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = (error) => reject(error);
                reader.readAsBinaryString(file);
            });
        },
        async readExcelFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = (error) => reject(error);
                reader.readAsBinaryString(file);
            });
        },
        classWinner(winner) {
            if (winner == 'WINNER') {
                return 'success'
            } else if (winner == 'LOSER') {
                return 'secondary'
            } else {
                return 'danger'
            }
        },


        printbarcoderef() {
            if (this.바코드출력 != '') {
                this.printbarcode(this.바코드출력)
            } else {
                if (this.SKU출력 != '') {
                    var barcode = this.$store.state.productdb.find(e => e["SKU ID"] == this.SKU출력)?.바코드
                    if (barcode) {
                        this.printbarcode(barcode);
                    } else {
                        alert('해당 SKU ID를 찾을 수 없습니다.')
                    }
                }
            }
        },
        printbarcodewith(event) {
            if (event.keyCode === 13) {
                this.printbarcode(event.target.value)
            }
        },
        printSKUwith(event) {
            if (event.keyCode === 13) {
                var barcode = this.$store.state.productdb.find(e => e["SKU ID"] == event.target.value)?.바코드
                if (barcode) {
                    this.printbarcode(barcode);
                } else {
                    alert('해당 SKU ID를 찾을 수 없습니다.')
                }
            }
        },
        printbarcode(barcode) {
            if (this.$store.state.productdb.length == 0 || !this.$store.state.productdb.find(e => e.바코드 == barcode)) {
                alert('상품DB에 존재하지 않은 바코드입니다. 상품DB를 업데이트한 후 다시 시도해 주세요')
                return
            } else {
                var ob = this.$store.state.productdb.find(e => e.바코드 == barcode)
                this.출력SKUID = ob['SKU ID'];
                this.출력바코드 = barcode;
                this.출력상품명 = ob['상품명'];
                this.한글표시사항 = {
                    '수입원/판매원': ob['수입원/판매원'],
                    제조원: ob.제조원,
                    제조국: ob.제조국,
                    내용량: ob.내용량,
                    '원료명및성분명(재질)': ob['원료명및성분명(재질)'],
                    상품유형: ob.상품유형,
                    사용시주의사항: ob.사용시주의사항,
                    사용기준: ob.사용기준,
                }
                setTimeout(() => {
                    this.print('printMe8');
                }, 10)
            }
        },


        // 검색 관련 메서드들
        performSearch() {
            this.showspinner = true;
            setTimeout(() => {
                let filteredProducts = [...this.productLists];

                if (this.searchBarcode.length > 0) {
                    filteredProducts = filteredProducts.filter(e =>
                        e.바코드 && e.바코드.includes(this.searchBarcode)
                    );
                }

                if (this.searchSKUID.length > 0) {
                    filteredProducts = filteredProducts.filter(e =>
                        e.SKUID && e.SKUID.toString().includes(this.searchSKUID)
                    );
                }

                if (this.searchProductName.length > 0) {
                    filteredProducts = filteredProducts.filter(e =>
                        e.상품명 && e.상품명.includes(this.searchProductName)
                    );
                }

                this.productLists = filteredProducts;
                this.showspinner = false;
            }, 100);
        },
        resetSearch() {
            this.searchBarcode = '';
            this.searchSKUID = '';
            this.searchProductName = '';
            this.loadProductData(); // 전체 데이터 다시 로드
        },

        // 매입정보 관리 모달 열기 (growthdb.vue 스타일)
        openImportInfoModal() {
            this.loadFlatImportInfos(); // 매입정보 데이터 로드
            this.filterImportInfos(); // 필터링 적용
            this.$bvModal.show('excelupload');
        },

        closeImportInfoModal() {
            this.$bvModal.hide('excelupload');
        },

        // 매입가격 계산
        calculateImportPrice(item) {
            const 매입단가 = parseFloat(item.매입단가) || 0;
            const 공급가액 = parseFloat(item.공급가액) || 0;
            const 부가세액 = parseFloat(item.부가세액) || 0;
            item.총매입가 = 매입단가 + 공급가액 + 부가세액;
        },

        // 매입정보 저장
        async saveImportInfoBatch() {
            try {
                const updateData = this.selectedImportItems.map(item => ({
                    SKUID: item.SKUID,
                    매입단가: item.매입단가,
                    공급가액: item.공급가액,
                    부가세액: item.부가세액,
                    총매입가: item.총매입가
                }));

                const response = await axios.post('/api/product/updateImportInfo', {
                    items: updateData
                });

                if (response.data.success) {
                    alert('매입정보가 성공적으로 저장되었습니다.');
                    this.loadProductData(); // 데이터 새로고침
                } else {
                    alert('매입정보 저장에 실패했습니다.');
                }
            } catch (error) {
                console.error('매입정보 저장 오류:', error);
                alert('매입정보 저장 중 오류가 발생했습니다.');
            }
        },

        // 매입정보 취소
        cancelImportInfo() {
            this.selectedImportItems = [];
        },

        // 파일 업로드 처리
        handleFileUpload(event) {
            this.uploadFile = event.target.files[0];
        },

        // Excel 업로드 (growthdb.vue 스타일)
        async uploadExcel(type) {
            const file = type === 'barcode' ? this.selectedFile2 : this.selectedFile;
            const statusKey = type === 'barcode' ? 'uploadstatus2' : 'uploadstatus';

            if (!file) {
                alert('업로드할 파일을 선택해주세요.');
                return;
            }

            this[statusKey] = '업로드 중...';

            try {
                const data = await this.readExcelFile(file);
                const workbook = XLSX.read(data, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);

                console.log('업로드된 데이터:', jsonData);

                // 서버로 데이터 전송
                const response = await axios.post('/api/product/updateImportInfo', {
                    data: jsonData,
                    type: type
                });

                if (response.data.success) {
                    alert(`매입가 업로드가 완료되었습니다. (${type} 방식)`);
                    this.loadProductData(); // 데이터 새로고침
                    this.loadFlatImportInfos(); // 매입정보 테이블 새로고침
                } else {
                    alert('업로드 중 오류가 발생했습니다: ' + response.data.message);
                }

            } catch (error) {
                console.error('Excel 업로드 오류:', error);
                alert('Excel 파일 업로드 중 오류가 발생했습니다.');
            } finally {
                this[statusKey] = '업로드';
                if (type === 'barcode') {
                    this.selectedFile2 = null;
                    if (this.$refs.excelFile2) this.$refs.excelFile2.value = '';
                } else {
                    this.selectedFile = null;
                    if (this.$refs.excelFile) this.$refs.excelFile.value = '';
                }
            }
        },

        // 매입정보 관련 메서드들 (growthdb.vue 스타일)
        getLatestImportPrice(item) {
            if (!item.매입정보 || item.매입정보.length === 0) return 0;
            const latest = item.매입정보.sort((a, b) => new Date(b.date) - new Date(a.date))[0];
            return latest.매입가 || 0;
        },
        getLatestImportDate(item) {
            if (!item.매입정보 || item.매입정보.length === 0) return '';
            const latest = item.매입정보.sort((a, b) => new Date(b.date) - new Date(a.date))[0];
            return latest.date || '';
        },
        loadFlatImportInfos() {
            this.flatImportInfos = [];
            this.productLists.forEach(product => {
                if (product.매입정보 && product.매입정보.length > 0) {
                    product.매입정보.forEach((importInfo, index) => {
                        this.flatImportInfos.push({
                            id: `${product.vendorItemId}_${index}`, // 고유 ID 생성
                            노출ID: product.productId,
                            옵션ID: product.vendorItemId,
                            상품명: product.상품명,
                            매입일자: importInfo.date,
                            매입가: importInfo.매입가,
                            editing: false,
                            originalData: { ...importInfo },
                            productRef: product, // 원본 상품 참조
                            importIndex: index // 매입정보 배열 인덱스
                        });
                    });
                }
            });
            this.filterImportInfos();
        },
        filterImportInfos() {
            let filtered = [...this.flatImportInfos];

            // 날짜 필터
            if (this.importInfoFilter.startDate) {
                filtered = filtered.filter(item => item.매입일자 >= this.importInfoFilter.startDate);
            }
            if (this.importInfoFilter.endDate) {
                filtered = filtered.filter(item => item.매입일자 <= this.importInfoFilter.endDate);
            }

            // 검색 필터
            if (this.importInfoFilter.searchText) {
                const searchText = this.importInfoFilter.searchText.toLowerCase();
                filtered = filtered.filter(item =>
                    item.옵션ID.toString().includes(searchText) ||
                    item.상품명.toLowerCase().includes(searchText)
                );
            }

            this.filteredImportInfos = filtered;
        },
        addNewImportInfo() {
            // 새 매입정보 추가 - 선택된 상품이 있는 경우에만
            if (this.selectedImportInfoItems.length === 0) {
                alert('매입정보를 추가할 상품을 선택해주세요.');
                return;
            }

            const today = new Date().toISOString().split('T')[0];
            this.selectedImportInfoItems.forEach(selectedItem => {
                const product = this.productLists.find(p => p.vendorItemId === selectedItem.옵션ID);
                if (product) {
                    if (!product.매입정보) product.매입정보 = [];
                    product.매입정보.push({
                        date: today,
                        매입가: 0
                    });
                }
            });

            this.loadFlatImportInfos(); // 테이블 새로고침
            this.changeCostForAll(); // 매입가 재계산
        },
        exportImportInfoToExcel() {
            // 매입정보 Excel 다운로드
            const exportData = this.filteredImportInfos.map(item => ({
                '노출ID': item.노출ID,
                '옵션ID': item.옵션ID,
                '상품명': item.상품명,
                '매입일자': item.매입일자,
                '매입가': item.매입가
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '매입정보');
            XLSX.writeFile(wb, '매입정보_' + new Date().toISOString().split('T')[0] + '.xlsx');
        },
        deleteSelectedImportInfo() {
            if (this.selectedImportInfoItems.length === 0) {
                alert('삭제할 매입정보를 선택해주세요.');
                return;
            }

            if (confirm(`선택된 ${this.selectedImportInfoItems.length}개의 매입정보를 삭제하시겠습니까?`)) {
                this.selectedImportInfoItems.forEach(selectedItem => {
                    const product = selectedItem.productRef;
                    if (product && product.매입정보) {
                        product.매입정보.splice(selectedItem.importIndex, 1);
                    }
                });

                this.loadFlatImportInfos(); // 테이블 새로고침
                this.changeCostForAll(); // 매입가 재계산
                this.selectedImportInfoItems = [];
            }
        },
        deleteAllImportInfo() {
            if (confirm('모든 매입정보를 삭제하시겠습니까?')) {
                this.productLists.forEach(product => {
                    if (product.매입정보) {
                        product.매입정보 = [];
                    }
                });

                this.loadFlatImportInfos(); // 테이블 새로고침
                this.changeCostForAll(); // 매입가 재계산
            }
        },
        editImportInfo(item) {
            item.editing = true;
            item.originalData = {
                매입일자: item.매입일자,
                매입가: item.매입가
            };
        },
        async saveImportInfoEdit(item) {
            try {
                // 원본 상품의 매입정보 업데이트
                const product = item.productRef;
                if (product && product.매입정보 && product.매입정보[item.importIndex]) {
                    product.매입정보[item.importIndex].date = item.매입일자;
                    product.매입정보[item.importIndex].매입가 = parseFloat(item.매입가) || 0;

                    // latestImportPrice 재계산 (무한 루프 방지)
                    product.latestImportPrice = this.calculateLatestImportPrice(product.매입정보);

                    // PurchaseDB에 저장 (growthdb.vue와 동일한 방식)
                    const success = await this.saveImportInfo(product, false);
                    if (success) {
                        // 매입가 재계산
                        this.changeCost(product);
                        this.changeMargin(product);

                        item.editing = false;
                        delete this.originalImportInfos[item.id];
                    } else {
                        // 실패시 원본 데이터로 복원
                        this.cancelImportInfoEdit(item);
                    }
                }
            } catch (error) {
                console.error('매입정보 저장 오류:', error);
                alert('저장 중 오류가 발생했습니다.');
                this.cancelImportInfoEdit(item);
            }

            this.매입정보없음 = this.productLists.filter(e => !e.매입가).length;
        },
        cancelImportInfoEdit(item) {
            item.editing = false;
            // 원본 데이터로 복원
            if (item.originalData) {
                item.매입일자 = item.originalData.매입일자;
                item.매입가 = item.originalData.매입가;
            }
        },
        async deleteImportInfo(item) {
            if (!confirm('이 매입정보를 삭제하시겠습니까?')) return;

            try {
                const product = item.productRef;
                if (!product || !product.매입정보) {
                    alert('상품 데이터를 찾을 수 없습니다.');
                    return;
                }

                // 매입정보에서 해당 항목 삭제
                product.매입정보.splice(item.importIndex, 1);

                // 서버에 저장
                const success = await this.saveImportInfo(product, false);
                if (success) {
                    // 마진 재계산
                    this.changeCost(product);
                    this.changeMargin(product);

                    // 플랫 데이터 다시 로드
                    this.loadFlatImportInfos();
                    this.filterImportInfos();

                    // 매입정보 없는 상품 수 업데이트
                    this.매입정보없음 = this.productLists.filter(e => !e.매입가).length;

                    alert('삭제되었습니다.');
                } else {
                    alert('삭제 실패');
                }
            } catch (error) {
                console.error('매입정보 삭제 오류:', error);
                alert('삭제 중 오류가 발생했습니다.');
            }
        },

        // 모든 상품의 매입가 재계산
        changeCostForAll() {
            this.productLists.forEach(product => {
                this.changeCost(product);
                this.changeMargin(product);
            });
            this.매입정보없음 = this.productLists.filter(e => !e.매입가).length;
        },

        handleFileSelect(event) {
            this.selectedFile = event.target.files[0];
        },
        handleFileSelect2(event) {
            this.selectedFile2 = event.target.files[0];
        },


    }
}
</script>
<style scoped>
::v-deep .my-dropdown-class {
    transform: translate3d(0px, -30px, 0px) !important;
    max-height: 150px;
    width: 400px;
    z-index: 9999;
    overflow-y: auto;
}

::v-deep .reqpo-modal-scrollable .modal-dialog {
    max-width: 90%;
    position: absolute;

    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

#quill-container {
    height: 50px;
}

#quill-container .ql-editor {
    min-height: unset;
}


.reqpo-action-button {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.reqpo-status {
    width: 100%;
    border: 3px solid #cccccc;
    display: flex;
    justify-content: space-between;
}

.reqpo-status-area {
    width: 30%;
    padding: 20px;
}

.reqpo-status-header {
    border-bottom: 1px solid #ccced2;
    text-align: center;
    margin-bottom: 12px;
}

.reqpo-status-tit {
    margin-bottom: 20px;
}

.reqpo-status-txt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.reqpo-status-txt a {
    cursor: pointer;
}

.reqpo-status-txt span {
    font-weight: bold;
}

.reqpo-purchase-request-form {
    padding: 1rem;
}

.reqpo-form-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
}

.reqpo-section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #dee2e6;
}

.reqpo-input-wrapper {
    margin-bottom: 1rem;
}

.reqpo-stock-info {
    font-size: 0.9rem;
    color: #6c757d;
}

.reqpo-info-label {
    color: #495057;
}

.reqpo-info-value {
    font-weight: 500;
    color: #212529;
}

.reqpo-separator {
    margin: 0 0.5rem;
    color: #adb5bd;
}

.reqpo-custom-radio-card {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.reqpo-custom-radio-card:hover {
    background: #e9ecef;
}

.reqpo-custom-radio-card.active {
    background: #e9ecef;
    border-color: #0d6efd;
}

.reqpo-card-title {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.reqpo-card-desc {
    font-size: 0.85rem;
    color: #6c757d;
}

.reqpo-text-muted {
    color: #6c757d;
    font-size: 0.85rem;
}

.reqpo-option-title {
    font-weight: 500;
    color: #495057;
}

.reqpo-option-group {
    background: #ffffff;
    border-radius: 6px;
    padding: 1rem;
    border: 1px solid #dee2e6;
}

.reqpo-warning-box {
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 6px;
    padding: 1rem;
}

.warning-title {
    font-weight: 600;
    color: #856404;
    margin-bottom: 0.5rem;
}

.reqpo-warning-text {
    color: #856404;
    font-size: 0.85rem;
    margin-top: 0.25rem;
}

.korean-label-form {
    background: #ffffff;
    border-radius: 6px;
    padding: 1.5rem;
    border: 1px solid #dee2e6;
}

.negotiation-options {
    background: #ffffff;
    border-radius: 6px;
    padding: 1rem;
    border: 1px solid #dee2e6;
}

.reqpo-modal-scrollable .modal-body {
    max-height: 80vh;
    overflow-y: auto;
}

.list-action {
    gap: 0.25rem;
}

.list-action .badge {
    cursor: pointer;
    transition: all 0.2s ease;
}

.list-action .badge:hover {
    transform: scale(1.1);
}

.reqpo-warning-box {
    background: #fff3cd;
    border: 1px solid #ffeeba;
    border-radius: 6px;
    padding: 1rem;
}

.reqpo-warning-text {
    color: #dc3545;
    font-size: 0.85rem;
    margin-top: 0.25rem;
}

.reqpo-option-group {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.reqpo-option-title {
    font-weight: 500;
    color: #495057;
    font-size: 0.9rem;
}

.reqpo-text-muted {
    font-size: 0.85rem;
}
</style>
